import { LitElement, html, css,TemplateResult, PropertyValues, nothing } from 'lit';
import {property, customElement} from 'lit/decorators.js';
import MGPlayerCore from '@maersk-global/player-core';
import { VoyageStyle } from '../../local_modules/voyage-style/src/voyage-style';

// Components
import '../../local_modules/voyage-map/src/voyage-map';
import { VoyageMap } from '../../local_modules/voyage-map/src/voyage-map';
import '../../local_modules/voy-alert-messages/src/voy-alert-messages';
import '../../local_modules/voyage-button/src/voyage-button';
import '../../local_modules/voyage-drawer-panel/src/voyage-drawer-panel';
import '../../local_modules/voyage-float-panel/src/voyage-float-panel';
import '../../local_modules/voyage-tooltip/src/voyage-tooltip';
import '../../local_modules/voyage-topbar/src/voyage-topbar';
import '../../local_modules/voyage-topbar/src/voyage-topbar-cloud';
import '../../local_modules/voyage-toggle-box/src/voyage-toggle-box';
import '../../local_modules/voyage-info/src/voyage-info';
import { VoyageInfo } from '../../local_modules/voyage-info/src/voyage-info';
import '../../local_modules/voyage-vessel-details/src/voyage-vessel-details';
import '../../local_modules/voyage-vessel-weather-control/src/voyage-vessel-weather-control';
import '../../local_modules/voyage-leg-details/src/voyage-leg-details';
import '../../local_modules/port-memo-popup/src/port-memo-popup';
import '../../local_modules/voyage-suggested-routes/src/voyage-suggested-routes';
import '../../local_modules/voyage-ship-weather-expectation-player/src/voyage-ship-weather-expectation-player';
import '../../local_modules/voyage-time-control/src/voyage-time-control';
import '../../local_modules/voyage-weather-limits/src/voyage-weather-limits';
import '../../local_modules/voyage-help-center/src/voyage-help-center';
import '../../local_modules/voyage-route-editor/src/voyage-route-editor';
import { getZoneCrossingSignature, routeNeedsWarningsReview, routeWarningsReviewed } from '../../src/utils/zone-crossing-utils';
import { VoyageSuggestedRoutes } from '../../local_modules/voyage-suggested-routes/src/voyage-suggested-routes';
import '../../local_modules/voyage-passage-plan/src/voyage-passage-plan';
import '../../local_modules/vessel-performance/src/vessel-performance-main';
import '../../local_modules/voyage-view-route/src/voyage-view-route';
import '../../local_modules/voy-chart-depths-control/src/voy-chart-depths-control';
import '../../local_modules/voy-eta-etd-popup/src/voy-eta-etd-popup';
import '../../local_modules/voy-tide-info-popup/src/voy-tide-info-popup';
import '../../local_modules/voy-tide-info-popup/src/voy-tide-graph';
import '../../local_modules/voy-add-terminal/src/voy-add-terminal.js';
import '../../local_modules/voy-vessel-chars-popup/src/voy-vessel-chars-popup';
import '../../local_modules/voy-vessel-chars-popup/src/voy-vessel-chars-popup-cloud';
import '../../local_modules/voy-vessel-position-popup/src/voy-vessel-position-popup';
import '../../local_modules/voy-vessel-position-alert/src/voy-vessel-position-alert';
import { VoyageDialogPopupManager } from '../../local_modules/voyage-dialog-popup/src/voyage-dialog-popup-manager';
import '../../local_modules/vessel-map-layers-selector/src/vessel-map-layers-selector';
import { LayerName } from '../../local_modules/vessel-map-layers-selector/src/vessel-map-layers-selector';
import '../../local_modules/vessel-edit-schedule/src/vessel-edit-schedule';
import '../../local_modules/voy-drafts-gmt-popup/src/voy-drafts-gmt-popup';
import '../../local_modules/voy-wp-eta-popup/src/voy-wp-eta-popup';
import '../../local_modules/voy-vessel-rs1345-popup/src/voy-vessel-rs1345-popup';
import '../../local_modules/voyage-vessel-alarm-popup/src/voy-vessel-alarm-popup'
import "../../local_modules/voy-vessel-alarm-log-list/src/voy-vessel-alarm-log-list";
import '../../local_modules/voy-feature-feedback-popup/voy-feature-feedback-popup';
import '../../local_modules/vessel-own-route-reason-popup/src/vessel-own-route-reason-popup';
import '../../local_modules/vessel-clf-popup/src/vessel-clf-popup';
import '../../local_modules/vessel-clf-popup/src/vessel-wr-clf-popup';
import '../../local_modules/vessel-wr-update-popup/src/vessel-wr-update-popup';
import { SvgIcons } from '../../local_modules/voyage-svg-icons/src/voyage-svg-icons';
import '../../local_modules/weather-service-alert/src/weather-service-alert';
import '../../local_modules/voyage-polar-plot/src/polar-charts-wrapper';
import '../../local_modules/imo-input-popup/src/imo-input-popup';
import '../../local_modules/voy-loader/src/voy-loader';
import '../../local_modules/voyage-map-view-options/src/voyage-map-view-options';

import { TraceService, setTraceService, EVENT_CATEGORIES } from '../../src/services/trace-service';
import { TraceServiceVessel } from '../../src/services/trace-service-vessel';

import { apiCallTracker } from '../../src/utils/api-call-tracker';
import { browserUptimeTracker } from '../../src/utils/browser-uptime-tracker';
import '../../local_modules/voyage-eta-change-review/src/eta-change-review-wrapper';
import '../../local_modules/voyage-eta-change-review/src/eta-change-requested-wrapper';
import { captureInstalledAppVersionMetrics, setImoInRealUserMonitoring, customRUMSession } from '../../src/utils/rum-utility';

// Models
import { MgLayers, setMgLayers } from '../../src/maplayers/mg-layers';
import { MgLayersImpl } from '../../src/maplayers/mg-layers-impl';
import { BufferLayers } from '../../src/maplayers/buffer-layer';
import { PlanningLayers } from '../../src/maplayers/planning-layers';
import { VesselPositionModelImpl } from '../../src/models/vessel-position-model-impl';
import { setVesselPositionModel } from '../../src/models/vessel-position-model';
import { ExecutionLayer } from '../../src/maplayers/execution-layer';
import { VesselLayer } from '../../src/maplayers/vessel-layer';
import { VesselTrackLayer } from '../../src/maplayers/vessel-track-layer';
import { VesselInTimeLayers } from '../../src/maplayers/vessel-in-time-layers';
import { UiStateModelImpl } from '../../src/models/ui-state-model-impl';
import { setUiStateModel, UiStateModel, UiStateModelParam } from '../../src/models/ui-state-model';
import { VoyageRoutingModelImpl } from '../../src/models/voyage-routing-model-impl';
import { CalculationFailedDetails, setVoyageRoutingModel, VoyageRoute, VoyageRoutingModel } from '../../src/models/voyage-routing-model';
import { setVoyageSchedulesModel, VoyageSchedulesModel } from '../../src/models/voyage-schedules-model';
import { VoyageSchedulesModelImpl } from '../../src/models/voyage-schedules-model-impl';
import { setProgressModel } from '../../src/models/progress-model';
import { ProgressModelImpl } from '../../src/models/progress-model-impl';
import { AlertType, setVesselAlertsModel, VesselAlertsModel } from '../../src/models/vessel-alerts-model';
import { VesselAlertsModelImpl } from '../../src/models/vessel-alerts-model-impl';
import { TerminalsModelImpl } from '../../src/models/terminals-model-impl';
import { setTerminalsModel, TerminalsModel } from '../../src/models/terminals-model';
import { VesselPlanningModelImpl } from '../../src/models/vessel-planning-model-impl';
import { PlanChangedEvent, setVesselPlanningModel, VoyagePlan } from '../../src/models/vessel-planning-model';
import { VesselPlanningModel } from '../../src/models/vessel-planning-model';
import { setWeatherModel } from '../../src/models/weather-model';
import { WeatherModelImpl } from '../../src/models/weather-model-impl';
import { SHOW_WNI_REPORT_POPUP, WeatherRoutingModelImpl } from '../../src/models/weather-routing-reports-model-impl';
import { setRouteEditModel } from '../../src/models/route-edit-model';
import { RouteEditModel } from '../../src/models/route-edit-model';
import { RouteEditModelImpl } from '../../src/models/route-edit-model-impl';
import { RouteEditLayer } from '../../src/maplayers/route-edit-layer';
import { VesselPerformanceModelImpl } from '../../src/models/vessel-performance-model-impl';
import { setVesselPerformanceModel } from '../../src/models/vessel-performance-model';
import { TidesModelImpl } from '../../src/models/tides-model-impl';
import { setTidesModel } from '../../src/models/tides-model';
import { VesselEnpBookAndChapterModelImpl } from '../../src/models/vessel-enp-book-and-chapter-model-impl';
import { setVesselEnpBookAndChapterModel } from '../../src/models/vessel-enp-book-and-chapter-model';
import { VesselNavAreasModelImpl } from '../../src/models/vessel-nav-areas-model-impl';
import { setVesselNavAreasModel } from '../../src/models/vessel-nav-areas-model';
import { setVesselRs1345Model, VesselRs1345Model } from '../../src/models/vessel-rs1345-model';
import { VesselRs1345ModelImpl } from '../../src/models/vessel-rs1345-model-impl';
import { setVesselRs6ModelModel } from '../../src/models/vessel-rs6-model';
import { VesselRs6ModelImpl } from '../../src/models/vessel-rs6-model-impl';
import { setWhaleZonesModel } from '../../src/models/whale-zones-model';
import { WhaleZonesModelImpl } from '../../src/models/whale-zones-model-impl';
import { setVoyageWeatherRoutingModel, VoyageWeatherRoutingModel } from '../../src/models/weather-routing-model';
import { WhaleZonesLayerAll } from '../../src/maplayers/whale-zones-layer-all';
import { WhaleZonesLayerInForce } from '../../src/maplayers/whale-zones-layer-in-force';
import { BWMModelImpl } from '../../src/models/bwm-zones-model-impl';
import { setBWMModel } from '../../src/models/bwm-zones-model';
import { setSecurityZonesModel } from '../../src/models/security-zones-model';
import { SecurityZonesModelImpl } from '../../src/models/security-zones-model-impl';
import { SecurityZonesLayer } from '../../src/maplayers/security-zones-layer';
import { setRestrictedAreasModel } from '../../src/models/restricted-areas-model-impl';
import { RestrictedAreasModelImpl } from '../../src/models/restricted-areas-model';
import { setEcaSecaModel } from '../../src/models/eca-seca-zones-model';
import { EcaSecaModelImpl } from '../../src/models/eca-seca-zones-model-impl';
import { MarpolModelImpl } from '../../src/models/marpol-zones-model-impl';
import { setMarpolModel } from '../../src/models/marpol-zones-model';
import { GetFormattedDate, GetFormattedDayMonth, GetUTCTimestamp, isOnline, UUID } from '../../src/utils/helpers';
import { EnpBooksAndChaptersLayer } from '../../src/maplayers/enp-books-and-chapters-layer';
import { NavAreasLayer } from '../../src/maplayers/nav-areas-layer';
import { getMostFuelEfficientStarRoute, getStarRouteDeviationSegments, SaveHydraLog } from '../../src/utils/route-utils';
import { isStarRouteDeviationEnabled } from '../../src/utils/helpers';
import { setPrecautionaryZonesModel } from '../../src/models/precautionary-zones-model';
import { PrecautionaryZonesModelImpl } from '../../src/models/precautionary-zones-model-impl';
import { PrecautionaryZonesLayer } from '../../src/maplayers/precautionary-zones-layer';
import "@maersk-global/mds-components-core/mc-toast";

/*START.DEV_ONLY*/
import '../../local_modules/voyage-routing-tester/src/voyage-routing-tester';
import { DevLayers } from '../../src/maplayers/dev-layers';
import { TraceServiceConsole } from '../../src/services/trace-service-console';
/*END.DEV_ONLY*/

import { OSM } from 'ol/source';
import { Tile, Vector } from 'ol/layer';
import VectorSource from 'ol/source/Vector';

import { TimeController } from '../../src/utils/time-controller';
import { MapCoordinates } from '../../local_modules/voyage-vessel-spot-weather-control/src/voyage-vessel-spot-weather-control';
import { Coordinate } from 'ol/coordinate';
import { verifyProtocol } from '../../src/utils/protocol-warning';
import { MarpolLayer } from '../../src/maplayers/marpol-layer';
import { EcaSecaLayer } from '../../src/maplayers/eca-seca-layer';
import { WeatherControlMode } from '../../local_modules/voyage-vessel-weather-control/src/voyage-vessel-weather-control';
import { SpotWeatherMarkerLayer } from '../../src/maplayers/spot-weather-marker-layer';
import { ShallowSoundingsLayer } from '../../src/maplayers/shallow-soundings-layer';
import { NavtexLayer } from '../../src/maplayers/navtex-layer';
import { NavtexLayerInForce } from '../../src/maplayers/navtex-layer-in-force';
import { downloadPlanWithSelectedRoute } from '../../src/utils/utils';
import { BWMLayer } from '../../src/maplayers/bwm-layer';
import { RestrictedAreasLayer } from '../../src/maplayers/restricted-areas-layer';
import { setVoyageBestPracticeRoutesModel } from '../../src/models/voyage-best-practice-routes-model';
import { VoyageBestPracticeRoutesModelImpl } from '../../src/models/voyage-best-practice-routes-model-impl';
import { ScheduleEntry } from '../../src/models/types/voyage-schedules-model.types';
import { Format } from '../../src/converters/types/converters.types';
import { setVesselAlarmsModel, VesselAlarmsModel, AlarmEvents } from "../../src/models/vessel-alarms-model";
import { VesselAlarmsModelImpl } from '../../src/models/vessel-alarms-model-impl';
import { NotificationTypes, VoyNotification } from '../../src/services/types/vessel-notifications-services.types';
import { VesselFeedbackStatusModelImpl } from '../../src/models/vessel-feedback-status-model-impl';
import { setVesselFeedbackStatusModel, VesselFeedbackStatusModel } from '../../src/models/vessel-feedback-status-model';
import { VesselRouteSelectionModelImpl } from '../../src/models/vessel-route-selection-model-impl';
import { setVesselRouteSelectionModel } from '../../src/models/vessel-route-selection-model';
import { VesselClfPopupModelImpl } from '../../src/models/vessel-clf-popup-model-impl';
import { setVesselClfPopupModel } from '../../src/models/vessel-clf-popup-model';
import { TerminalGeofencesModelImpl } from '../../src/models/terminal-geofences-model-impl';
import { setTerminalGeoFencesModel } from '../../src/models/terminal-geofences-model';
import "../../local_modules/vessel-predeparture-popup/src/vessel-predeparture-popup"
import { ACCEPT_SHOW_PLAN, VoyageWeatherRoutingModelImpl } from '../../src/models/weather-routing-model-impl';
import { WeatherRoutingModel, setWeatherRoutingModel } from '../../src/models/weather-routing-reports-model';
import { ENCDataService } from '../../src/services/enc-data-service';
import "../../local_modules/reports/src/report-triggers"
import { ShowMinimizePopUp } from '../../local_modules/reports/type/modal-for-report-type';
import { VesselLoaderManager } from '../../local_modules/vessel-loader/src/vessel-loader-manager';
import { SuggestedRouteEvents } from '../../local_modules/voyage-suggested-routes/src/types';
import { StarRouteDeviationLayer } from '../../src/maplayers/star-route-deviation-layer'
import { VesselNotificationsService } from '../../src/services/vessel-notifications-service';
import { PolarRouteLayer, PolarRouteLayerEvents } from '../../src/maplayers/polar-route-layer';
import { IMO, VoyageImoModel } from '../../src/models/voyage-imo-model';
import { VoyageImoEventNames } from '../../src/models/voyage-imo-model-impl';
import { OnlineStatusController } from '../../src/utils/online-status-controller';
import { setVesselNotificationsModel } from '../../src/models/vessel-notifications-model';
import { VesselNotificationsModelImpl } from '../../src/models/vessel-notifications-model-impl';
import { BackGroundOptimizationModelImpl } from '../../src/models/vessel-background-optimization-model-impl';
import { IndexedDBSyncService } from '../../indexed-db/services/sync_db_service';
import { setBackGroundOptimizationModel } from '../../src/models/vessel-background-optimization-model';
import { offlineBackgroundSyncManual } from '../../src/utils/offline-utils';
import { NotificationMessageType } from '../../local_modules/voyage-passage-plan/src/voyage-passage-plan-overview/type';
import { ScheduleChangeModel, setScheduleChangeModel } from '../../src/models/schedule-change-model';
import { ScheduleChangeEvents, ScheduleChangeModelImpl } from '../../src/models/schedule-change-model-impl';
import { formatEtaDate } from '../../local_modules/voyage-eta-change-review/src/helper';
import { PolarMarkerLayer } from '../../src/maplayers/polar-marker-layer';
import { ImminentRiskModel, setImminentRiskModel } from '../../src/models/imminent-risk-model';
import { ImminentRiskEvents, ImminentRiskModelImpl } from '../../src/models/imminent-risk-model-impl';
import { LoadstarEvents, LoadstarModel, setLoadstarModel } from '../../src/models/loadstar-model';
import { LoadstarModelImpl } from '../../src/models/loadstar-model-impl';
import '../../local_modules/audio-alert/src/onboard-audio-alert';
import '../../local_modules/audio-alert/src/test-audio';
import '../../local_modules/loadstar-review/src/loadstar-review-wrapper';
import { CONST_POW_ENDPOINT_V2, FeatureFlagModel, FeatureFlagsEvents, setFeatureFlagModel } from '../../src/models/feature-flag-model';
import { FeatureFlagModelImpl, ISHIGHLIGHTSHALLOWSOUNDINGSENABLED, ISIMMINENTRISKENABLED, ISLOADSTARENABLED, ISOPENOCCEANROUTEENABLED, ISTRINITYENABLED, ISWEATHERROUTINGENABLED } from '../../src/models/feature-flag-model-impl';
import { RouteOptimizerService } from '../../src/services/route-optimiser-service';
import { PolarLoadingModalEventNames } from '../../local_modules/voyage-polar-plot/src/polar-loading-modal';
import { _formatDate } from '../../local_modules/vessel-predeparture-popup/utils/vessel-departure-utils';
export type FloatPanelComponent = "schedule" | "suggestedRoutes" | "routeEditor" | "viewRoute" | "scheduleEditor" | "alarmLogs" | "polarPlot" | "etaChangeRequest";
export type MenuComponent = "showLayersSelector" | "showPerformance" | "showWeather" | "--";

const isVesselOnCloud: boolean = (window as any).appenv?.vesselOnCloud;
const showMapViewOptions = (<any>window)["appenv"].showMapViewOptions;
const getCurrentVesselImo = (): IMO => isVesselOnCloud ? VoyageImoModel!.imo : (<any>window)["appenv"].vesselIMONumber;
const OOR_READINESS_STALE_THRESHOLD_HOURS = 7;
@customElement('main-app')
export class MainApp extends LitElement {
    alarmsCount: number=0
    @property({ type: Boolean }) private _isOwnRouteMoreEfficientModalVisible: boolean = false;
    @property({ type: Boolean }) private showPolarChart: boolean = false;
    private _vesselImoNumber: IMO = null;
    @property({type: Boolean}) private hasParametricRisk: boolean = false;
    @property({ type: Object, attribute: false }) plan: VoyagePlan | null = null
    @property({ type: Object, attribute: false }) hoursToEtd: number | null = null;
    @property({ type: Object, attribute: false }) upcomingSchedule: any = null;
    private onlineStatus = new OnlineStatusController(this);
    private OFFLINE_START_KEY = 'offlineStartTime';

    @property({type: Boolean}) private hasImminentRisk: boolean = false;
    @property({ type: Object, attribute: false }) CounterProposalNotification: any = null;
    @property({ type: Array }) private minimizedViews: { name: string; type: NotificationTypes }[] = [];
    @property({ type: Boolean }) showOnboardAudioModal = false;
    @property({ type: Boolean }) showLoadstarReviewModal = false;
    @property({ type: Number }) log_id: number | null = null;

    @property({ type: Boolean }) private _showHeavyRollingToast: boolean = false;
    @property({ type: Object }) private _heavyRollingData: { data: any; id: string | number } | null = null;
    @property({ type: Boolean }) private _showHighAccelerationForceToast: boolean = false;
    @property({ type: Object }) private _highAccelerationForceData: { data: any; id: string | number } | null = null;

    private _pollingInterval: ReturnType<typeof setInterval> | undefined = undefined;
    @property({ type: Boolean }) _hideFloatPanel = false;
    @property({ type: Boolean }) _showEtaChangeFloatPanel = false;
    @property({ type: Boolean }) _WeatherRoutingOn: boolean = false;
    @property({ type: Boolean }) _TrinityOn: boolean = false;
    @property({ type: Boolean }) _ImminentRiskOn: boolean = false;
    @property({ type: Boolean }) _LoadstarOn: boolean = false;
    
    @property({type: Boolean}) private showEtaRequest = false;
    @property({ type: Boolean }) showTestAudioAlert: boolean = false;

    @property({ attribute: false }) private customFilterOpened: boolean = false;

    constructor() {
        super();

        this._vesselImoNumber = VoyageImoModel!.imo;
        verifyProtocol();

        let traceToConsole = false;
        /*START.DEV_ONLY*/
        traceToConsole = true;
        /*END.DEV_ONLY*/
        setTraceService(traceToConsole ? new TraceServiceConsole() : new TraceServiceVessel());
        
        // Initialize feature flags 
        const featureFlagModel = new FeatureFlagModelImpl();
        setFeatureFlagModel(featureFlagModel);
        
        // Set up feature flag initialization and model loading
        this._initializeFeatureBasedModels(featureFlagModel);

        setUiStateModel(new UiStateModelImpl());
        setVoyageSchedulesModel(new VoyageSchedulesModelImpl());
        setVesselPositionModel(new VesselPositionModelImpl());
        setVesselPlanningModel(new VesselPlanningModelImpl());
        setVoyageRoutingModel(new VoyageRoutingModelImpl());
        setWeatherModel(new WeatherModelImpl());
        setRouteEditModel(new RouteEditModelImpl());
        setVesselPerformanceModel(new VesselPerformanceModelImpl());
        setTerminalsModel(new TerminalsModelImpl());
        setTidesModel(new TidesModelImpl());
        setVesselAlertsModel(new VesselAlertsModelImpl());
        setVesselEnpBookAndChapterModel(new VesselEnpBookAndChapterModelImpl());
        setVesselNavAreasModel(new VesselNavAreasModelImpl());
        setVesselRs1345Model(new VesselRs1345ModelImpl());
        setVesselRs6ModelModel(new VesselRs6ModelImpl());
        setWhaleZonesModel(new WhaleZonesModelImpl());
        setMarpolModel(new MarpolModelImpl());      
        setEcaSecaModel(new EcaSecaModelImpl());
        setBWMModel(new BWMModelImpl());
        setRestrictedAreasModel(new RestrictedAreasModelImpl());
        setSecurityZonesModel(new SecurityZonesModelImpl());
        setPrecautionaryZonesModel(new PrecautionaryZonesModelImpl());
        setVoyageBestPracticeRoutesModel(new VoyageBestPracticeRoutesModelImpl());
        setVesselAlarmsModel(new VesselAlarmsModelImpl());
        setVesselFeedbackStatusModel(new VesselFeedbackStatusModelImpl());
        setVesselNotificationsModel(new VesselNotificationsModelImpl());
        setBackGroundOptimizationModel(new BackGroundOptimizationModelImpl());
        setVesselRouteSelectionModel(new VesselRouteSelectionModelImpl());
        setVesselClfPopupModel(new VesselClfPopupModelImpl());
        setTerminalGeoFencesModel(new TerminalGeofencesModelImpl());
            
        // Feature-based models will be initialized asynchronously after feature flags load
        this._playerCore = new TimeController({
            startTime: Date.now(),
            playbackRate: 1800,
        }).player;
        setMgLayers(new MgLayersImpl(this._playerCore));
        this._onPlanChanged = this._onPlanChanged.bind(this);
        this._onExecutingPlanChanged = this._onExecutingPlanChanged.bind(this);
        this._calculationFailedErrorPopUp = this._calculationFailedErrorPopUp.bind(this);
        VoyageRoutingModel!.addEventListener("calculation-failed", <EventListener>(this._calculationFailedErrorPopUp));
        this._onAcceptLegDetailsShowPlan = this._onAcceptLegDetailsShowPlan.bind(this);
        this.__renderFloatPanelMenu = this.__renderFloatPanelMenu.bind(this);
        // Weather routing event listeners will be set up after feature flags load
        this._showAdviceModalHandler = this._showAdviceModalHandler.bind(this);
        this._showWrPdfModalHandler = this._showWrPdfModalHandler.bind(this);
        this._renderAlarmLogs = this._renderAlarmLogs.bind(this)
        this._openFeedBackPopup = this._openFeedBackPopup.bind(this)
        this._toggleMoreFuelEfficientModal = this._toggleMoreFuelEfficientModal.bind(this)
        this._updateNumberOfActiveFilters = this._updateNumberOfActiveFilters.bind(this)
        this._resetMap = this._resetMap.bind(this)
        this._getMapConfig = this._getMapConfig.bind(this)
        this._closeCustomFilterPopup = this._closeCustomFilterPopup.bind(this);
        this._openFeedBackPopup();
        setInterval(this._openFeedBackPopup, 24 * 60 * 60 * 1000);
        this._checkEtaEtdAlerts();  
        setInterval(this._checkEtaEtdAlerts, 5 * 60 * 1000);
        this._checkENCUpdates();
        setInterval(this._checkENCUpdates.bind(this), 60 * 60 * 1000); // Check every hour
        captureInstalledAppVersionMetrics();
        this.getUpcomingSchedule.bind(this);
        this.checkPlanApproval();
        this.checkPreDepaturePlan();
        customRUMSession();
        // Initialize API call tracker for RUM metrics
        apiCallTracker.initialize().catch(err => {
            console.error('Failed to initialize API call tracker:', err);
        });

        // restrict uptime tracking to vessel users only, unless testing in dev environment
        const shouldTrackUptime = (<any>window)["appenv"].rumConfig.environment === "dev" ? true : sessionStorage.getItem('isVesselUser') === 'Yes';

        // Initialize browser uptime tracker for RUM metrics
        if(shouldTrackUptime) {
            browserUptimeTracker.initialize().catch(err => {
                console.error('Failed to initialize browser uptime tracker:', err);
            });
        }

        // Optional: check every 10 mins if 72 hrs reached
        setInterval(() => {
            if (this.hasExceeded72HoursOffline()) {
            console.warn('App has been offline for 72 hours continuously.');
            // handle logic: alert user, log, etc.
            }
        }, 10 * 60 * 1000);
        setImoInRealUserMonitoring();
        this.handleRemindLater = this.handleRemindLater.bind(this);

        // Counter proposal notifications will be handled after feature flags load
    }

    private _calculationFailedErrorPopUp(evt: CustomEvent<CalculationFailedDetails>) {
        const headerText = "A Technical Error Has Occured";
        let bodyText = `A technical error has occured while trying to calculate route`;
        if (evt.detail.routeIndex !== undefined) {
            bodyText = `A technical error has occured while trying to calculate Route ${evt.detail.routeIndex + 1}`;
        }

        if (evt.detail.hydraRequestId) {
            bodyText += `\n\nClick "Download Error Log" to generate a log file and send it attached in an e-mail support\nticket. Support will try to fix it as soon as possible.`;

            let errorDetails = "";
            // Use validation error response from hydra when/if we recognize the format

            // Hydra format 1
            // This is the format used by Hydra versions prior to the February 2022 release
            if (evt.detail.hydraErrorBody && evt.detail.hydraErrorBody.validation_error && evt.detail.hydraErrorBody.validation_error.body_params &&
                evt.detail.hydraErrorBody.validation_error.body_params instanceof Array) {
                let hydraValidationErrors = "";
                for (const entry of evt.detail.hydraErrorBody.validation_error.body_params) {
                    if (entry.msg && typeof entry.msg === "string") {
                        hydraValidationErrors += entry.msg + "\n";
                    }
                }
                if (hydraValidationErrors !== "") {
                    errorDetails = "Power calculation engine reports the following issue(s):\n" + hydraValidationErrors;
                }
            }

            // Hydra format 2
            // This is the format mistakenly used for validation errors during request parsing in the Hydra February 2022 release
            if (evt.detail.hydraErrorBody && evt.detail.hydraErrorBody.detail &&
                evt.detail.hydraErrorBody.detail instanceof Array) {
                let hydraValidationErrors = "";
                for (const entry of evt.detail.hydraErrorBody.detail) {
                    if (entry.msg && typeof entry.msg === "string") {
                        hydraValidationErrors += entry.msg + "\n";
                    }
                }
                if (hydraValidationErrors !== "") {
                    errorDetails = "Power calculation engine reports the following issue(s):\n" + hydraValidationErrors;
                }
            }

            // Hydra format 3
            // This is the format used for all validation errors after the Hydra February 2022 release and some validation
            // errors in the February 2022 release (like checking drafts and reefer consumption against the vessel model)
            if (evt.detail.hydraErrorBody && evt.detail.hydraErrorBody.errors &&
                evt.detail.hydraErrorBody.errors instanceof Array) {
                let hydraValidationErrors = "";
                for (const entry of evt.detail.hydraErrorBody.errors) {
                    // The message will usually be something like "field required", so prefix this with the path when it is available
                    // This will result in error messages like "route_geometry.0.leg_type: field required"
                    let pathPrefix = "";
                    if (entry.paths && entry.paths instanceof Array) {
                        pathPrefix = entry.paths.join(".") + ": ";
                    }
                    if (entry.message && typeof entry.message === "string") {
                        hydraValidationErrors += pathPrefix + entry.message + "\n";
                    }
                }
                if (hydraValidationErrors !== "") {
                    errorDetails = "Power calculation engine reports the following issue(s):\n" + hydraValidationErrors;
                }
            }

            const dialog = VoyageDialogPopupManager.createDialog({
                headerText: headerText,
                bodyText: bodyText,
                errorDetails: errorDetails,
                acceptButtonText: "Download error log",
                rejectButtonText: "Cancel",
                isError: true,
                noCloseButton: true
            });

            dialog.getResponse().then((response) => {
                if (response === "accept") {
                    SaveHydraLog(evt.detail.hydraRequestId!);
                }
            });
        }
        else {
            VoyageDialogPopupManager.createDialog({
                headerText: headerText,
                bodyText: bodyText,
                errorDetails: evt.detail.error,
                isError: true
            });
        }
    }

    static get styles() {
        return [
            css`
                :host {
                    margin: 0;
                    padding: 0;
                    display: flex;
                    flex-direction: column;
                    position: fixed;
                    top: 0;
                    bottom: 0;
                    right: 0;
                    left: 0;
                }
                .main {
                    width: 100%;
                    flex-grow: 1;
                }

                .star-route-deviation-footnote {
                    font-size: 0.875rem;
                    line-height: 1.25;
                    margin-top: 0.875rem;
                    padding-top: 0.625rem;
                    border-top: 1px solid var(--neutrals-grey-5);
                }

                .star-route-deviation-footnote__heading {
                    font-size: 0.8125rem;
                    font-weight: 700;
                    margin-bottom: 0.125rem;
                }

                .star-route-deviation-footnote__legend {
                    display: flex;
                    align-items: center;
                    gap: 0.375rem;
                    margin-top: 0.375rem;
                }

                .star-route-deviation-footnote__line {
                    display: inline-block;
                    width: 3.25rem;
                    height: 0.1875rem;
                    background: repeating-linear-gradient(
                        to right,
                        currentColor 0,
                        currentColor 1rem,
                        transparent 1rem,
                        transparent 1.375rem,
                        currentColor 1.375rem,
                        currentColor 1.5625rem,
                        transparent 1.5625rem,
                        transparent 1.9375rem
                    );
                }

                voyage-topbar {
                    z-index: 10;
                }

                voyage-topbar-cloud {
                    z-index: 10;
                }

                voyage-map {
                    width: 100%;
                    height: 100%;
                }

                .alertsContainer {
                    flex-grow: 1;
                    min-width: 100px;
                    /* flex-grow makes this stretch to fill whatever space isn't taken by
                       the button row, which is usually far wider than any alert actually
                       showing - re-enabling pointer-events here (as this used to do) makes
                       that whole empty stretch swallow mousedown/drag and block map pan.
                       Individual alert children opt back in below where they actually
                       paint visible, interactive content. */
                    pointer-events: none;
                    display: flex;
                    flex-direction: column;
                    gap: 12px;

                }

                .alertsContainer > * {
                    width: 100%;
                }

                /* voy-alert-messages scopes its own pointer-events internally (its visible
                   banner is narrower than its stretched host), so it isn't listed here. */
                .alertsContainer > voy-vessel-position-alert,
                .alertsContainer > mc-notification {
                    pointer-events: auto;
                }

                voyage-player-controls {
                    width: 100%;
                    height: 56px;
                    position:fixed;
                    bottom:0;
                    left:0;
                    z-index: 1000;
                }

                voyage-button {
                    fill: var(--neutrals-grey-04, grey);
                    font-family: var(--component-heading-ff, 'serif');
                    font-size: 14px;
                    line-height: 20px;
                    font-weight: normal;
                    height: 32px;
                }

                voyage-button > span {
                    color: var(--neutrals-grey-03, black);
                }

                voyage-button > svg {
                    height: 14px;
                }

                .panel-button-row {
                    position: fixed;
                    top: 55px;
                    right: 5px;
                    left: 435px;

                    display: flex;
                    align-items: flex-start;
                    pointer-events: none;
                }

                .panel-button-row voyage-button {
                    margin-left: 10px;
                    pointer-events: auto;
                }

                .timecontrol {
                    z-index: 1;
                    width: 100%;
                    height: 56px;
                }

                .debugmsg {
                    position: fixed;
                    bottom: 0;
                    right: 0;
                    width: auto;
                    height: auto;
                    padding: 4px;
                    background-color: rgba(0,0,0,0.5);
                    color: white;
                    font-family: var(--component-heading-ff, 'serif');
                    font-size: var(--component-heading-size, 20px);
                    line-height: var(--component-heading-height, 20px);
                    font-weight: var(--component-heading-weight, normal);
                }

                .info-content {
                    width: 175px;
                    height: auto;
                }

                .refresh {
                    position: absolute;
                    right: 60px;
                    bottom: 60px;
                    background: var(--primary-blue-05, blue);
                    color: var(--neutrals-grey-10, white);
                    border-radius: 3px;
                    padding: 5px;
                    height: 20px;

                    text-align: center;
                    font-family: var(--component-paragraph-ff, 'serif');
                    font-size: var(--component-paragraph-size, 14px);
                    line-height: var(--component-paragraph-height, 20px);
                    font-weight: var(--component-paragraph-weight, normal);

                    animation-name: flash;
                    animation-duration: 3s;
                    animation-timing-function: linear;
                    animation-iteration-count: infinite;

                    cursor: pointer;
                }
                .predeparture-styles{
                    display: flex;
                    justify-content: center; 
                    pointer-events: auto;
                    width: 100%
                }

                @keyframes flash {
                    0% { opacity: 1.0; }
                    50% { opacity: 0.3; }
                    100% { opacity: 1.0; }
                }

                .close-modal-styles{
                    display: flex;
                    justify-content: flex-end;
                    margin-top: 20px;
                }
                .modal-iframe-style{
                    border:none; 
                    min-width:1000px; 
                    min-height:600px;
                }
                .hidden-float-panel {
                    visibility: hidden;
                    pointer-events: none;
                    opacity: 0;
                }
                .notification--action {
                    text-decoration: underline;
                    cursor: pointer;
                    background: none;
                    border: none;
                    padding: 0;
                    font-family: inherit;
                    font-size: inherit;
                    margin-top: 6px;
                }
            `
        ];
    }

    private _toggleMoreFuelEfficientModal(isVisible: boolean) {
        this._isOwnRouteMoreEfficientModalVisible = isVisible;
        this.requestUpdate('_isOwnRouteMoreEfficientModalVisible');
    }

    private _showHelpCenter() {
        // The panel keeps its own sub-page state, so a menu click while it is already
        // open must explicitly send it back to the Help Center home view.
        (this.shadowRoot?.querySelector('voyage-help-center') as any)?.resetToHome();
        this.showHelpCenter = true;
    }

    private _showWniReportPopUp() {
        const WniReportIds = JSON.parse(
            localStorage.getItem('WNIReports') || '{}',
        )
        let reportId = 0;
        if(WniReportIds[this.currentPlan?.scheduleId ?? '']) {
            const currentScheduleReport = WniReportIds[this.currentPlan?.scheduleId ?? '']
            reportId = currentScheduleReport ? currentScheduleReport['departureReport'] : 0
        }

        WeatherRoutingModel!.dispatchEvent(
            new CustomEvent(SHOW_WNI_REPORT_POPUP, {
                detail: {
                    minimizedPopUp: true,
                    reportType: 'Departure',
                    scheduleId: this.currentPlan?.scheduleId,
                    reportId: reportId,
                    fromNotification: false,
                },
            }),
            )
    }

    
    render() {
        let alarmsCount = VesselAlarmsModel!.alarmsWithoutResponses.length ?? 0;

        
        return html`
            ${isVesselOnCloud ? html`<voyage-topbar-cloud app-name="Vessel Voyage"
                           @show-depths-control=${ () => this.showDepthsControl = true }
                           @show-polar-chart=${(e: CustomEvent) => this._togglePolarChartFloatPanel({ toggle:true, event: e })}
                           @show-weather-limits=${ () => this.showWeatherLimits = true }
                           @show-restriction-areas=${ () => this._notImplemented() }
                           @show-vessel-characteristics=${ () => this.showVesselCharsInput = true }
                           @show-vessel-position=${ () => this.showVesselPositionPopup = true }
                           @show-wni-reports=${()=> this._showWniReportPopUp()}
                           @show-alarm-logs=${() => this._renderAlarmLogs()}
                           @show-help-center=${() => this._showHelpCenter()}
                           @show-feedback-form=${() => this._triggerUserFeedback()}
                           show-forecast-info include-vessel-settings
                           @show-polar-route-selection=${()=>this.togglePolarTopBar(true)}
                           @close-polar-route-selection=${()=>this.togglePolarTopBar(false)}
                           @show-audio-alert=${()=> this.showTestAudioAlert = true}
                           .polarRouteCapturedPosition=${this.polarRouteCapturedPosition}
                           .hasParametricRisk=${this.hasParametricRisk}
                           .showPolarTopBar=${this.showPolarTopBar}
                           .showImoError=${this.showImoError}
                           .hasActivePlan=${!!this.currentPlan}
                           >
                        </voyage-topbar-cloud>` 
                        : html`<voyage-topbar app-name="Vessel Voyage"
                           @show-depths-control=${ () => this.showDepthsControl = true }
                           @show-polar-chart=${(e: CustomEvent) => this._togglePolarChartFloatPanel({ toggle:true, event: e })}
                           @show-weather-limits=${ () => this.showWeatherLimits = true }
                           @show-restriction-areas=${ () => this._notImplemented() }
                           @show-vessel-characteristics=${ () => this.showVesselCharsInput = true }
                           @show-vessel-position=${ () => this.showVesselPositionPopup = true }
                           @show-wni-reports=${()=> this._showWniReportPopUp()}
                           @show-alarm-logs=${() => this._renderAlarmLogs()}
                           @show-help-center=${() => this._showHelpCenter()}
                           @show-feedback-form=${() => this._triggerUserFeedback()}
                           show-forecast-info include-vessel-settings
                           @show-polar-route-selection=${()=>this.togglePolarTopBar(true)}
                           @close-polar-route-selection=${()=>this.togglePolarTopBar(false)}
                           @show-audio-alert=${()=> this.showTestAudioAlert = true}
                           .polarRouteCapturedPosition=${this.polarRouteCapturedPosition}
                           .hasParametricRisk=${this.hasParametricRisk}
                           .showPolarTopBar=${this.showPolarTopBar}
                           .showImoError=${this.showImoError}
                           .hasActivePlan=${!!this.currentPlan}
                           .ImminentRiskOn=${this._ImminentRiskOn}
                           >
                        </voyage-topbar>`
                }
            <div class="main">
               <weather-service-alert></weather-service-alert>
               ${isVesselOnCloud ? html `
                    <imo-input-popup></imo-input-popup>
                    <voy-loader label="Preparing application with new vessel data..."></voy-loader>
                `: html ``}
        
                <voyage-map .vesselInTimePosition=${this.vesselInTimePosition}
                            .showPolarAdviceLegend=${this.showPolarChart}
                            @mapcoord=${this._onMapCoord}
                            @mapcoordmove=${this._onMapCoordMove}
                            @change-wp-eta-clicked=${this._onChangeWPEtaClicked}
                            .minimizedViews=${this.minimizedViews}>
                </voyage-map>
                ${!this.showPolarTopBar ? html`<div class="panel-button-row">
                    <div class="alertsContainer">
                        <voy-vessel-position-alert></voy-vessel-position-alert>
                        ${this.renderHeavyRollingWarning()}
                        ${this.renderHighAccelerationForceWarning()}
                        ${this._renderStarRouteDeviationBanner()}
                        <voy-alert-messages imo=${this._vesselImoNumber}></voy-alert-messages>
                    </div>
                    ${this._devButtons()}
                    ${ (isVesselOnCloud && showMapViewOptions) ? html`
                    <voyage-button
                        .focused=${this._showMapViewOptions}
                        ?toggled=${false} @click=${() => this._onMapViewOptionsClick()}>
                        <span class="map-switch-options">Map View</span>
                    </voyage-button>
                    ` : html ``}
                    <voyage-button ?toggled=${this.showMenuComponent === 'showLayersSelector'} @click=${() => { this._switchMenuComponent('showLayersSelector') }}>
                        <span>${SvgIcons.customShowLayersIcon} Show/Hide...</span>
                    </voyage-button>
                    <voyage-button ?toggled=${this.showMenuComponent === 'showPerformance'} @click=${() => { this._switchMenuComponent('showPerformance') }}>${SvgIcons.solidAnalytics}
                        <span>Performance</span>
                    </voyage-button>
                    <voyage-button ?toggled=${this.showMenuComponent === 'showWeather'} @click=${() => { this._switchMenuComponent('showWeather') }}>
                        ${SvgIcons.cloud}<span>Weather</span>
                    </voyage-button>
                </div>` : ''}
                
                ${this.__renderFloatPanelMenu()}
                ${this._renderStarRouteDeviationBanner()}
                ${this.showAdviceModal ? this._showAdviceModal() : ''}
                <report-buttons .showMinimizePopUp=${this.showMinimizePopUp}></report-buttons>
                <voyage-toggle-box class="info-content" visible-top=100 guard-top=${window.innerHeight - 160} ?shown=${this.showInfoBox} transparent>
                   <voyage-info class="info-content"></voyage-info>
                </voyage-toggle-box>
                <voyage-vessel-weather-control ?shown=${this.showMenuComponent === 'showWeather'} @spot-weather-set=${this._onSpotWeatherSet} @spot-weather-tooltip=${this.onSpotWeatherTooltip} .mode=${this.showInFloatPanel} .playerTime=${this.playerTime} .mapCoordinates=${this.mapCoordinates}></voyage-vessel-weather-control>
                <vessel-performance-main ?shown=${this.showMenuComponent === 'showPerformance'} .mode=${this.showInFloatPanel} .plan=${this.currentPlan} .playerTime=${this.playerTime}></vessel-performance-main>
                <vessel-map-layers-selector ?shown=${this.showMenuComponent === 'showLayersSelector'} @selection-changed=${this._onLayersSelectionChanged}></vessel-map-layers-selector>
                ${this._devPanels()}
                ${(isVesselOnCloud &&showMapViewOptions) ? html`
                <voyage-drawer-panel 
                .triggered=${this.triggered}  
                .filterResult=${this.filterResult} 
                class="map-view-options-panel" ?showMapViewOptions=${this._showMapViewOptions} ?shown=${this._showMapViewOptions} 
                @filters-changed=${this._updateNumberOfActiveFilters} @close=${() => {this._showMapViewOptions = false}} 
                drawerTitle="Map View" ?showOnTop=${true}>
                    <voyage-map-view-options ?shown=${this._showMapViewOptions} @map-view-option-changed=${this._onMapViewSelectionChangedEvent}></voyage-map-view-options>
                </voyage-drawer-panel>
                <custom-filter-popup id="customFilterPopup" ?shown="${this.customFilterOpened}" @filters-changed=${this._updateNumberOfActiveFilters} @close="${this._closeCustomFilterPopup}"></custom-filter-popup>
                ` : html``}
            </div>
           
            <div class="timecontrol">
                <voyage-time-control @playbackrate-update=${(evt: CustomEvent) => this._playbackRateUpdate(evt)}
                                     @toggle-play=${(evt: CustomEvent) => this._togglePlayer(evt)}
                                     @focustime-update=${(evt: CustomEvent) => this._focustimeUpdate(evt)}
                                     .playerTime=${this.playerTime}
                                     .planningScheduleId=${this.planningScheduleId}
                                     .mode=${this.showInFloatPanel}>
                </voyage-time-control>
            </div>
            ${this.debugmsg ? html`<div class="debugmsg">${this.debugmsg}</div>` : ''}
            <voyage-leg-details @accept-voyage-details=${() => this._onAcceptLegDetails()} @cancel=${() => this.showLegDetails = false } ?shown=${this.showLegDetails} schedule-id=${this.planningScheduleId} .imminenetRiskOn=${this._ImminentRiskOn}>
            </voyage-leg-details>
            <voyage-weather-limits @accept=${() => this._onAcceptWeatherLimits()} @cancel=${() => this.showWeatherLimits = false }
                                   @max-roll-angle-limit=${(e: CustomEvent) => this.companyMaxRollAngleLimit = e.detail.maxRollAngle}
                                   ?shown=${this.showWeatherLimits} schedule-id=${this.planningScheduleId}>
            </voyage-weather-limits>
            <voyage-passage-plan @close=${this._closePassagePlan} .toggleFuelEfficientModal=${this._toggleMoreFuelEfficientModal} .readOnly=${this.showInFloatPanel === "viewRoute"}
                                 ?shown=${this.showPassagePlan} schedule-id=${this.planningScheduleId} .nonHydraCalculatedRoute=${this.selectedNonHydraCalculatedRoute} showInFloatPanel = ${this.showInFloatPanel}>
            </voyage-passage-plan>
            <port-memo-popup ?shown=${this.portMemoShowPopup} terminal-code=${this.portMemoTerminalCode} @close=${() => { this.portMemoShowPopup = false; this.portMemoTerminalCode = ""}}>
            </port-memo-popup>
            <mc-toast
                appearance="success"
                ?open=${this._isOwnRouteMoreEfficientModalVisible}
                duration="10000"
                @close=${() => this._toggleMoreFuelEfficientModal(false)}
                position="top-center" >
                <mc-notification heading="Thank you" icon="check-circle" body="Congratulations, you have just made a more fuel efficent voyage plan than StarRoute"></mc-notification>
            </mc-toast>
            <mc-toast
                appearance="success"
                ?open=${this._vesselCharacteristicsSaved}
                duration="10000"
                @close=${() => this._vesselCharacteristicsSaved = false}
                position="bottom-center" >
                <mc-notification icon="check-circle" body="All the details have been saved."></mc-notification>
            </mc-toast>    
            ${this.renderHeavyAlarmAcceptedToast()}
            <voy-add-terminal ?shown=${this.addTerminalShowPopup} terminal-code=${this.addTerminalLocationID} unlocode=${this.addTerminalUnlocode} 
                                 @close=${() => this.addTerminalShowPopup = false }
                                 @accept=${() => this.addTerminalShowPopup = false } >
            </voy-add-terminal>
            
            <voy-chart-depths-control ?shown=${this.showDepthsControl} @close=${() => this.showDepthsControl = false }>
            </voy-chart-depths-control>
            <voy-eta-etd-popup ?shown=${this.showEtdInput || this.showEtaInput} ?etd=${this.showEtdInput} .scheduleId=${this.planningScheduleId}
                               @close=${() => { this.showEtdInput = false; this.showEtaInput = false; }}>
            </voy-eta-etd-popup>
            <voy-wp-eta-popup ?shown=${this.showWPEtaInput} .wpPlanIndex=${this.wpPlanIndex}
                              @close=${() => this.showWPEtaInput = false}>
            </voy-wp-eta-popup>
            <voy-drafts-gmt-popup ?shown=${this.showDraftsInput} .scheduleId=${this.planningScheduleId}
                                  @close=${() => { this.showDraftsInput = false; }}>
            </voy-drafts-gmt-popup>
            <voy-tide-info-popup ?shown=${this.showTideInfoPopup} @close=${() => this.showTideInfoPopup = false } .gsisEntry=${this.tideInfoPopupGsisEntry}></voy-tide-info-popup>
            ${isVesselOnCloud ? html`<voy-vessel-chars-popup-cloud .shown=${this.showVesselCharsInput} @close=${() => {this.showVesselCharsInput = false; this._vesselCharacteristicsSaved = true;}}>
            </voy-vessel-chars-popup-cloud>`: html`<voy-vessel-chars-popup .shown=${this.showVesselCharsInput} @close=${() => this.showVesselCharsInput = false}>
            </voy-vessel-chars-popup>`}
            <voy-vessel-alarm-popup 
                @check-more-alarms=${(evt: CustomEvent) => { this._CheckForMoreAlarms(evt.detail) }}
                .alarms=${this._alarms}
				.alarm=${this._alarm}
                .shown=${alarmsCount > 0 && this.isAlarmPopupOpen}
                @close=${() => this.isAlarmPopupOpen = false}
                .hasActiveImminentRisk=${this.hasImminentRisk}>
            </voy-vessel-alarm-popup>
            <voy-vessel-position-popup ?shown=${this.showVesselPositionPopup}  @close=${() => this.showVesselPositionPopup = false}>
            </voy-vessel-position-popup>
            <voyage-help-center ?shown=${this.showHelpCenter} @close=${() => this.showHelpCenter = false}>
            </voyage-help-center>
            <voy-vessel-rs1345-popup ?shown=${this.showRs1345Popup} @close=${() => this.showRs1345Popup = false} .displayedHtml=${this.rs1345Html} .address=${this.rs1345Address}></voy-vessel-rs1345-popup>
            ${isVesselOnCloud ? html `` : html `<voy-feature-feedback-popup .shown=${this._showFeedback} .showCloseIcon=${this.showCloseIcon}></voy-feature-feedback-popup>`} 
            <vessel-own-route-reason-popup></vessel-own-route-reason-popup>
            <vessel-clf-popup></vessel-clf-popup>
            ${
                this._WeatherRoutingOn ? html`
                <vessel-wr-clf-popup></vessel-wr-clf-popup>
                <wr-update-clf-popup></wr-update-clf-popup>` : nothing
            }
            <loadstar-review-wrapper ?shown=${this.showLoadstarReviewModal} @close=${() => { this.showLoadstarReviewModal = false; }}></loadstar-review-wrapper>
            
            ${this._showEtaChangeFloatPanel
            ? this._renderEtaChangeRequest()
            : nothing}
            ${this._ImminentRiskOn && this.showOnboardAudioModal ? html`<onboard-audio-alert @close=${() => {this.showOnboardAudioModal = false}} @minimized=${() => {this.showOnboardAudioModal = false; const alreadyExists = this.minimizedViews.some(v => v.type === NotificationTypes.ImminentRiskOnboard);
                        if (!alreadyExists) {
                            this.minimizedViews = [
                            ...this.minimizedViews,
                            { name: 'Introducing Audio Alert', type: NotificationTypes.ImminentRiskOnboard },
                            ];
                        }}}></onboard-audio-alert>` : nothing}
            ${this._ImminentRiskOn && this.showTestAudioAlert ? html`<test-audio-alert @close=${() => {this.showTestAudioAlert = false}}></test-audio-alert>` : nothing}
        `;
    }

    onSpotWeatherTooltip(evt: CustomEvent) {
        this._enableSpotWeatherTooltip(evt.detail.enable);
    }

    firstUpdated() {
        this._mapElement = this.shadowRoot!.querySelector('voyage-map');

        this._voyageInfo = this.shadowRoot!.querySelector('voyage-info');

        this.playerTime = this._playerCore.currentTime;
        this._playerCore.addEventListener('timeupdate', () => {
            this.playerTime = this._playerCore.currentTime;
        });

        this._assignModels(this._getMapConfig(localStorage.getItem('selectedMapView') || "simplified"));

        //add schedules and plans to the indexed-db on first load
        if(isVesselOnCloud) {
            if(this._vesselImoNumber)UiStateModel!.setValue(UiStateModelParam.IMO, this._vesselImoNumber.toString())
                localStorage.setItem('isSlowNetworkOfflineMode', 'No');
        }
        
        VoyageStyle.addEventListener('styles-changed', () => this._stylesChanged() );

        this._checkVesselCharacteristics();
        
        UiStateModel!.addEventListener(`${UiStateModelParam.MainMenuComponent}-change`, () => this._onUIComponentsChanged());
        UiStateModel!.addEventListener(`${UiStateModelParam.SelectedWeatherControlComponent}-change`, () => this._onUIComponentsChanged());
        localStorage.removeItem('warningPoints');
    }

    async getUpcomingSchedule(){
        try{
            const scheduleEntries = await VoyageSchedulesModel!.getScheduleFor((<any>window)["appenv"].
            vesselIMONumber);
            if (!scheduleEntries)
                {
                    return
                }

                const activeEntryIndex = scheduleEntries.findIndex(entry => entry.active);

                if (activeEntryIndex !== -1) {
                    this.upcomingSchedule = scheduleEntries[activeEntryIndex + 1] || null;
                } else {
                    this.upcomingSchedule = scheduleEntries[0];
                }
        } catch (e) {
            console.error(e);
        }  
    }

    async checkPlanApprovalStatus() {
        try {
            if (!this.upcomingSchedule?.id) {
                console.log("No upcoming schedule found.");
                return;
            }
    
            const plan: VoyagePlan | null = await VesselPlanningModel!.getCurrentPlan(this.upcomingSchedule.id);
    
            // Check if the plan is approved
            if (plan && plan.status === "approved") {
                VesselAlertsModel!.removeAlertsByType((<any>window)["appenv"].vesselIMONumber, AlertType.NoPlanPreEtd);
            } else {
                console.log("Plan not approved yet or not found.");
            }
        } catch (error) {
            console.error("Error checking plan approval:", error);
        }
    }

    async checkOpenOceanRouteReadiness() {
        try {
            // OOR pipeline-health monitoring is only relevant in dev/sit, not for vessel users in prod
            if ((<any>window)["appenv"].rumConfig?.environment !== "dev") {
                return;
            }

            if (localStorage.getItem(ISOPENOCCEANROUTEENABLED) !== 'true') {
                return;
            }

            const imo = getCurrentVesselImo();
            if (!imo) {
                return;
            }

            const readiness = await RouteOptimizerService.getOORReadiness(String(imo));
            const lastSuccessfulCalculationAt = readiness?.lastSuccessfulCalculationAt;

            const isStale = !lastSuccessfulCalculationAt
                || (Date.now() - new Date(lastSuccessfulCalculationAt).getTime()) > OOR_READINESS_STALE_THRESHOLD_HOURS * 60 * 60 * 1000;

            if (isStale) {
                const message = lastSuccessfulCalculationAt
                    ? `The last successful Open Ocean Route calculation completed at ${_formatDate(new Date(lastSuccessfulCalculationAt))}.`
                    : 'No successful Open Ocean Route calculation has completed yet.';

                VesselAlertsModel!.addAlert(imo, {
                    id: 'open-ocean-route-readiness-warning',
                    message,
                    type: AlertType.OpenOceanRouteReadinessWarning,
                });
            } else {
                VesselAlertsModel!.removeAlertsByType(imo, AlertType.OpenOceanRouteReadinessWarning);
            }
        } catch (error) {
            console.error("Error checking Open Ocean Route readiness:", error);
        }
    }

    private async checkOpenOceanRouteReadinessForSchedule(scheduleId: string) {
        if (!scheduleId) {
            return;
        }

        const imo = getCurrentVesselImo();
        if (!imo) {
            return;
        }

        const scheduleEntries = await VoyageSchedulesModel!.getScheduleFor(imo);
        const scheduleEntry = scheduleEntries?.find(entry => entry.id === scheduleId);

        if (scheduleEntry?.isOORAvailable) {
            this.checkOpenOceanRouteReadiness();
        }
    }

    private _CheckForMoreAlarms(alarms: VoyNotification<NotificationTypes.Alarm>[]) {
		if (alarms.length) {
			this.isAlarmPopupOpen = true;
			this._alarm = alarms[0];
		} else {
            this.isAlarmPopupOpen = false;
        }
		this.alarmsCount = VesselAlarmsModel!.alarms.length ?? 0;
	}
    

    updated(changedProperties: PropertyValues)
    {

        const executionLayer = this._executionLayer?.layer;
        const planningLayers = this._planningLayers?.layers;
        const bufferLayers = this._bufferLayers?.layers;
        const starRouteDeviationLayer = this._starRouteDeviationLayer?.layer;
        if(changedProperties.has("showPolarTopBar")) {
            const isVisible = this.showPolarTopBar;
            planningLayers?.forEach(layer => layer.setVisible(!isVisible))
            bufferLayers?.forEach(layer => layer.setVisible(!isVisible))
            starRouteDeviationLayer?.setVisible?.(!isVisible && ["suggestedRoutes", "routeEditor"].includes(this.showInFloatPanel))
            executionLayer?.setVisible(!isVisible);
            this._polarRouteLayer?.layers.forEach(layer => layer.setVisible(isVisible))
            if(isVisible) {
                RouteEditModel!.clear();
            } 
        }

        else if (changedProperties.has("showInFloatPanel"))
        {

            const isVisible = ["schedule", "scheduleEditor", "alarmLogs", "etaChangeRequest", "viewRoute"].includes(this.showInFloatPanel);
            this._executionLayer?.layer?.setVisible(isVisible);

            // Shallow soundings are only meaningful for the route being actively planned
            // (matches ShallowSoundingsLayer's own "suggestedRoutes"/"routeEditor" check), so
            // disable the layer outside of route planning instead of leaving it visible
            // (enable() is never paired with a disable() elsewhere).
            const isRoutePlanningView = ["suggestedRoutes", "routeEditor"].includes(this.showInFloatPanel);
            starRouteDeviationLayer?.setVisible?.(isRoutePlanningView);
            if (isRoutePlanningView && localStorage.getItem(ISHIGHLIGHTSHALLOWSOUNDINGSENABLED) === 'true') {
                this._shallowSoundingsLayer?.enable();
            } else {
                this._shallowSoundingsLayer?.disable();
                // The alert banner is rendered globally (outside the float panel), so it
                // outlives the view it was raised in unless we clear it here too.
                const imo = getCurrentVesselImo();
                if (imo) {
                    VesselAlertsModel!.removeAlertsByType(imo, AlertType.ShallowSoundingsWarning);
                    VesselAlertsModel!.removeAlertsByType(imo, AlertType.StarRouteNegativeUkcWarning);
                }
            }
        }
    }
    

    @property({attribute: false}) private showInFloatPanel: FloatPanelComponent = "schedule";
    // Zone point key ("lon,lat|zoneId") the route editor should scroll to when it opens, set when
    // the user clicks a precautionary zone marker on the map. Cleared once the editor is left.
    @property({attribute: false}) private _focusZoneKey: string = '';
    @property({attribute: false}) private debugmsg: string = "";
    @property({attribute: false}) private showRouteTester: boolean = false;
    @property({attribute: false}) private showInfoBox: boolean = false;
    @property({attribute: false}) private playerTime: number = -1;
    @property({attribute: false}) private showLegDetails: boolean = false;
    @property({attribute: false}) private showWeatherLimits: boolean = false;
    @property({attribute: false}) private showPassagePlan: boolean = false;
    @property({attribute: false}) private planningScheduleId: string = "";
    @property({attribute: false}) private vesselInTimePosition: Coordinate|null = null;
    @property({attribute: false}) private polarRouteCapturedPosition: Coordinate|null = null;
    @property({attribute: false}) private polarRouteCapturedPositionETA: string|null = null;
    @property({attribute: false}) private companyMaxRollAngleLimit: number = 13;
    @property({attribute: false}) private portMemoShowPopup: boolean = false;
    @property({attribute: false}) private portMemoTerminalCode: string = "";
    @property({attribute: false}) private addTerminalShowPopup: boolean = false;
    @property({attribute: false}) private addTerminalLocationID: string = "";
    @property({attribute: false}) private addTerminalUnlocode: string = "";
    @property({attribute: false}) private showMenuComponent: string = "";
    @property({attribute: false}) private currentPlan: VoyagePlan|null = null;
    @property({attribute: false}) private showDepthsControl: boolean = false;
    @property({attribute: false}) private showEtdInput: boolean = false;
    @property({attribute: false}) private showEtaInput: boolean = false;
    @property({attribute: false}) private showWPEtaInput: boolean = false;
    @property({attribute: false}) private wpPlanIndex: number = -1;
    @property({attribute: false}) private showDraftsInput: boolean = false;
    @property({attribute: false}) private showVesselCharsInput: boolean = false;
    @property({attribute: false}) private showVesselPositionPopup: boolean = false;
    @property({attribute: false}) private showHelpCenter: boolean = false;
    @property({attribute: false}) private showTideInfoPopup: boolean = false;
    @property({attribute: false}) private showRs1345Popup: boolean = false;
    @property({attribute: false}) private tideInfoPopupGsisEntry: ScheduleEntry|null = null;
    @property({attribute: false}) private mapCoordinates: MapCoordinates|null = null;
    @property({attribute: false}) private rs1345Html: string = '';
    @property({attribute: false}) private rs1345Address: string = '';
    @property({attribute: false}) private selectedNonHydraCalculatedRoute: VoyageRoute|null = null;
    @property({ attribute: false }) private isAlarmPopupOpen: boolean = false;
    @property({ attribute: false }) private _alarm: VoyNotification<NotificationTypes.Alarm> | null = null;
    @property({ attribute: false }) private _alarms: VoyNotification<NotificationTypes.Alarm>[] = [];
    @property({ attribute: true }) private _showFeedback: boolean = false;
    @property({ attribute: true }) private showCloseIcon: boolean = false;
    @property({ attribute: false }) private showPolarTopBar: boolean = false;
    @property({ attribute: true }) private _selectedRouteId: string = '';
    @property({ attribute: true }) private _selectedStarRoute: string = '';
    @property({attribute: false}) private showImoError: boolean = false;
    @property({ attribute: true }) private _selectedRoute: string = '';
    @property({ attribute: true }) showMinimizePopUp: ShowMinimizePopUp = {minimizedPopUp: true,reportType:"",scheduleId:"",reportId:""};
    @property({ type: String }) private _heavyRollingAcceptStatus: 'error' | 'success' | null = null;
    @property({attribute: false}) private _showMapViewOptions: boolean = false;
    @property({attribute: false}) private _numberOfActiveFilters: number = 0;
    @property({attribute: false}) private _numberOfVessels: number = 0;

    private _playerCore: MGPlayerCore;
    private _routeEditLayer: RouteEditLayer|null = null;
    private _polarRouteLayer: PolarRouteLayer|null = null;
    private _voyageInfo: VoyageInfo|null = null;
    private _mapElement: VoyageMap|null = null;
    private _executionLayer: ExecutionLayer|null = null;
    private _vesselLayer: VesselLayer|null = null;
    private _vesselTrackLayer: VesselTrackLayer|null = null;
    private _planningLayers: PlanningLayers|null = null;
    private _bufferLayers: BufferLayers|null = null;
    private _starRouteDeviationLayer: StarRouteDeviationLayer|null = null;
    private _vesselInTimeLayers: VesselInTimeLayers|null = null;
    private _enpBooksAndChaptersLayer: EnpBooksAndChaptersLayer|null = null;
    private _navAreasLayer: NavAreasLayer|null = null;
    private _whaleZonesLayerAll: WhaleZonesLayerAll|null = null;
    private _whaleZonesLayerInForce: WhaleZonesLayerInForce|null = null;
    private _marpolLayer: MarpolLayer|null = null;
    private _ecaSecaLayer: EcaSecaLayer|null = null;
    private _spotWeatherMarkerLayer: SpotWeatherMarkerLayer|null = null;
    private _shallowSoundingsLayer: ShallowSoundingsLayer|null = null;
    private _navtexAllLayer: NavtexLayer|null = null;
    private _navtexInForceLayer: NavtexLayerInForce|null = null;
    private _bwmLayer: BWMLayer|null = null;
    private _restrictedAreasLayer: RestrictedAreasLayer|null = null;
    private _securityLayer: SecurityZonesLayer|null = null;
    private _precautionaryZonesLayer: PrecautionaryZonesLayer|null = null;
    private _vesselCharacteristicsSaved: boolean = false;
    private _polarMarkerLayer: PolarMarkerLayer|null = null;


    _onSpotWeatherSet(evt: CustomEvent) {
        this._spotWeatherMarkerLayer!.setCoordinates(evt.detail.coordinates);
        this._spotWeatherMarkerLayer!.enable();
    }

    private _enableSpotWeatherTooltip(enabled: boolean) {
        enabled ? this._mapElement!.setTooltipText("Spot weather", [{renderLine: () => html`<span>Click to show weather in this location</span>`}]) 
        : this._mapElement!.removeTooltipText("Spot weather");
    }

    private _onUIComponentsChanged() {
        const menuComponent: MenuComponent = <MenuComponent>(UiStateModel!.getValue(UiStateModelParam.MainMenuComponent));
        const weatherControlMode: WeatherControlMode = <WeatherControlMode>(UiStateModel!.getValue(UiStateModelParam.SelectedWeatherControlComponent));

        if (!(menuComponent === "showWeather" && weatherControlMode === "showSpot")) {
            this._enableSpotWeatherTooltip(false);
            this._spotWeatherMarkerLayer!.disable();
        }

        if (weatherControlMode !== "showSpot") {
            this._enableSpotWeatherTooltip(false);
            this._spotWeatherMarkerLayer!.disable();
        }

        if (menuComponent === "showWeather" && weatherControlMode === "showSpot") {
            this._spotWeatherMarkerLayer!.enable();
        }

        if(menuComponent === "--"){
            this._switchMenuComponent('');
        }
    }
    
    private _onLayersSelectionChanged(evt: CustomEvent<{layer: LayerName, value: boolean}>) {
        evt.detail.value ? UiStateModel!.setValue(UiStateModelParam.SelectedMapLayer, evt.detail.layer) : UiStateModel!.setValue(UiStateModelParam.SelectedMapLayer, "");

        if (evt.detail.layer === "Coordinates") {
            this.showInfoBox = evt.detail.value;
            return;
        }

        if (evt.detail.layer === "Sailing directions") {
            evt.detail.value ? this._enpBooksAndChaptersLayer!.enable() : this._enpBooksAndChaptersLayer!.disable();
            return;
        }

        if (evt.detail.layer === "Nav areas") {
            evt.detail.value ? this._navAreasLayer!.enable() : this._navAreasLayer!.disable();
            return;
        }

        if (evt.detail.layer === "Whale zones (All)") {
            evt.detail.value ? this._whaleZonesLayerAll!.enable() : this._whaleZonesLayerAll!.disable();
            return;
        }

        if (evt.detail.layer === "Whale zones (In force)") {
            evt.detail.value ? this._whaleZonesLayerInForce!.enable() : this._whaleZonesLayerInForce!.disable();
            return;
        }

        if (evt.detail.layer === "Marpol") {
            evt.detail.value ? this._marpolLayer!.enable() : this._marpolLayer!.disable();
            return;
        }

        if (evt.detail.layer === "ECA/SECA") {
            evt.detail.value ? this._ecaSecaLayer!.enable() : this._ecaSecaLayer!.disable();
            return;
        }

        if (evt.detail.layer === "Navtex stations (All)") {
            evt.detail.value ? this._navtexAllLayer!.enable() : this._navtexAllLayer!.disable();
            return;
        }

        if (evt.detail.layer === "Navtex stations (In force)") {
            evt.detail.value ? this._navtexInForceLayer!.enable() : this._navtexInForceLayer!.disable();
            return;
        }

        if (evt.detail.layer === "Ballast Water Management") {
            evt.detail.value ? this._bwmLayer!.enable() : this._bwmLayer!.disable();
            return;
        }
        if (evt.detail.layer === "Security zones") {
            evt.detail.value ? this._securityLayer!.enable() : this._securityLayer!.disable();
            return;
        }
        if (evt.detail.layer === "Precautionary Zones") {
            evt.detail.value ? this._precautionaryZonesLayer!.enable() : this._precautionaryZonesLayer!.disable();
            return;
        }
    }

    private _tracingAnalyticsOnClick(elementName: string) {
        TraceService!.event(EVENT_CATEGORIES.VESSEL_MAIN_APP, 'click', elementName);
    }

    private _switchMenuComponent(component: string) {
        this.showMenuComponent === component ? this.showMenuComponent = '' : this.showMenuComponent = component;
        UiStateModel!.setValue(UiStateModelParam.MainMenuComponent, this.showMenuComponent);
        this._tracingAnalyticsOnClick(component);
    }

    private _onMapViewOptionsClick() {
        this._showMapViewOptions = !this._showMapViewOptions;
        if (this._showMapViewOptions) {
            // this._showGlobalFilters = false;
            // this._showLayersSelector = false;
            // this._weatherDrawerSelected = null;
            // this._vesselListHandler(false);
        }
    }

    _closeCustomFilterPopup() {
        this.customFilterOpened = false;
        this.requestUpdate();
    }

    private async _closePassagePlan(evt: CustomEvent) {
        this.showPassagePlan = false;

        if (this.currentPlan && this.currentPlan.status === "approved" && evt.detail.passagePlanExitView === "Overview")
        {
            downloadPlanWithSelectedRoute(this.currentPlan!, Format.VoyagePlanning)
        }

        if (this.showInFloatPanel != "schedule" && this.currentPlan!.status === "approved") {
            this._showSchedule();
            
        }
    }



    private _tempScheduleId: string = "";

    private _devButtons() {
        // get current executing scheduleId
        VesselPlanningModel?.getExecutingPlan().then((res)=>{
            this._tempScheduleId = res!?.scheduleId;
        });


/*START.DEV_ONLY*/
        return html`
                <voyage-button @click=${() => {this.showRouteTester = true}}>${SvgIcons.lightRoute}
                    <span>Route Tester</span>
                </voyage-button>
            `;
/*END.DEV_ONLY*/
        return '';
    }

    @property({ attribute: false }) filterResult?: string;
    @property({ attribute: false }) triggered:boolean = false;

    private _updateNumberOfActiveFilters(e: CustomEvent) {
        this._numberOfActiveFilters = e.detail.numberOfActiveFilters;
        this._numberOfVessels = this._numberOfActiveFilters > 0 ? this._numberOfVessels : 0;
    }

    private _resetMap(){
        this._mapElement?.getMap()?.removeLayer(new Tile({source: new OSM()}));
        this._mapElement?.getMap()?.removeLayer(new Vector({source: new VectorSource()}));
        this._mapElement?.getMap()?.dispose();
    }

    private _onMapViewSelectionChanged(selectedOption: string) {
        this._assignModels(this._getMapConfig(selectedOption));
    }

    private async _onMapViewSelectionChangedEvent(evt: CustomEvent) {
        evt.preventDefault();
        if(evt.detail.selectedOption !== UiStateModel?.getValue(UiStateModelParam.SelecteMapView)){
            this._resetMap();
            this._assignModels(this._getMapConfig(evt.detail.selectedOption));
        }
    }

    private _getMapConfig(selectedOption: string){
        let mapConfig = {
            simplified: "true",
            level: "0",
        }
        switch (selectedOption) {
            case "simplified":
                mapConfig = {
                    simplified: "true",
                    level: "0",
                }
              break;
            case "basic":
                mapConfig = {
                    simplified: "false",
                    level: "0",
                }
              break;
            case "standard":
                mapConfig = {
                    simplified: "false",
                    level: "1",
                }
              break;
            case "advanced":
                mapConfig = {
                    simplified: "false",
                    level: "2",
                }
              break;
            }
        return mapConfig;
    }

    private _devPanels() {
/*START.DEV_ONLY*/
        return html`<voyage-drawer-panel ?shown=${this.showRouteTester}
            @close=${() => {this.showRouteTester = false}} title="Route tester">
            <voyage-routing-tester></voyage-routing-tester>
            </voyage-drawer-panel>
            `;
/*END.DEV_ONLY*/
        return '';
    }

    private __renderFloatPanelMenu() {
        UiStateModel!.setValue(UiStateModelParam.ApplicationMode, this.showInFloatPanel);

        switch (this.showInFloatPanel)
        {
            case "schedule":
                return this._renderCurrentSchedule();
            case "suggestedRoutes":
                return this._renderSuggestedRoutes();
            case "routeEditor":
                return this._renderRouteEditor();
            case "viewRoute":
                return this._renderViewRoute();
            case "scheduleEditor":
                return this._renderScheduleEditor();
            case "alarmLogs":
                return this._renderAlarmLogs();
            case "polarPlot":
                return this._renderPolarPlot();
        }
    }

    private _renderEtaChangeRequest() {
        const innerHtml = this.showEtaRequest
            ? html`<eta-change-requested-wrapper @back-clicked=${() => this._showEtaChangeFloatPanel = false} @hide-panel=${() => this.hideFloatPanel()} @show-panel=${() => this.showFloatPanel()}></eta-change-requested-wrapper>`
            : html`
                <eta-change-review-wrapper @back-clicked=${() => this.handleBack()} @hide-panel=${() => this.hideFloatPanel()} @show-panel=${() => this.showFloatPanel()}
                    @minimize=${() => {
                        this._showEtaChangeFloatPanel = false;
                        const alreadyExists = this.minimizedViews.some(v => v.type === NotificationTypes.RequestETAChange);
                        if (!alreadyExists) {
                            this.minimizedViews = [
                            ...this.minimizedViews,
                            { name: 'ETA Change', type: NotificationTypes.RequestETAChange },
                            ];
                        }
                    }}>
                </eta-change-review-wrapper>
            `;

        return this._renderFloatPanelForLoading("ETA Change Request", innerHtml);
    }

    private handleBack = () =>{
        this.showEtaRequest = false;

        this._showEtaChangeFloatPanel = false;
        const imo = getCurrentVesselImo();
        if (imo) {
            VesselAlertsModel!.removeAlertsByType(imo, AlertType.EtaChangeRemindLater);
        }
        this.minimizedViews = this.minimizedViews.filter(v => v.type !== NotificationTypes.RequestETAChange);
    }

    private removeImminentRiskMinimizedView = () => {
        this.minimizedViews = this.minimizedViews.filter(v => v.type !== NotificationTypes.ImminentRisk);
        this.hasImminentRisk = false;
    }

    private hideFloatPanel(){
        this._hideFloatPanel = true;
    }

    private showFloatPanel(){
        this._hideFloatPanel = false;
    }

    private _renderPolarPlot() {
        const innerHtml = html`<polar-charts-wrapper .plan=${this.currentPlan} .companyMaxRollAngleLimit=${this.companyMaxRollAngleLimit} @load-success=${() => this.showPolarChart = true} @active-imminent-risk=${() => this.hasImminentRisk = true} .polarRouteCapturedPosition=${this.polarRouteCapturedPosition} .polarRouteCapturedPositionETA=${this.polarRouteCapturedPositionETA} @back-clicked=${() => this._onFloatPanelBack()}
                    @minimized=${() => {this._onFloatPanelBack(); const alreadyExists = this.minimizedViews.some(v => v.type === NotificationTypes.ImminentRisk);
                        if (!alreadyExists) {
                            this.minimizedViews = [
                            ...this.minimizedViews,
                            { name: 'Polar Chart', type: NotificationTypes.ImminentRisk },
                            ];
                        }
                    }} @close-polarplot-loader=${() => this._onFloatPanelBack()} .showPolarChart=${this.showPolarChart} .log_id=${this.log_id} .imminentRiskOn=${this._ImminentRiskOn}></polar-charts-wrapper>`;
        return this._renderFloatPanel("Polar Plot",innerHtml);
    }

    private _togglePolarChartFloatPanel({event, toggle}: {event?: CustomEvent, toggle: boolean} ) {
        this.showPolarTopBar = false;
        if(toggle) {
            this.showInFloatPanel = "polarPlot";
            this.polarRouteCapturedPosition = event?.detail.position;
        } else {
            this._showSchedule();
            this.polarRouteCapturedPosition = null;
            this.polarRouteCapturedPositionETA = null;
        }
    }

    private togglePolarTopBar(toggle: boolean){
        this.showPolarTopBar = toggle;
        if(toggle) {
            this._renderFloatPanel("Polar Plot");
        }
        else {
            this._showSchedule();
            this.polarRouteCapturedPosition = null;
            this.polarRouteCapturedPositionETA = null;
        } 
    }

    private _renderRouteEditor() {
        const innerHtml = html`<voyage-route-editor @close-editor=${this._onFloatPanelBack} .planningScheduleId=${this.planningScheduleId} .selectedStarRoute=${this._selectedStarRoute} .selectedRouteId=${this._selectedRouteId} .plan=${this.currentPlan}
                                                    .focusZoneKey=${this._focusZoneKey}
                                                    @zone-point-focused=${(e: CustomEvent) => this._planningLayers?.setSelectedZonePoint(e.detail.key)}
                                                    .setStarRouteLayerVisibility=${this.setStarRouteLayerVisibility.bind(this)} >
                                </voyage-route-editor>`;

        // The badge next to the panel title tracks the review: red "Needs Review" while the edited
        // route still has unacknowledged precautionary zone crossings, green "Reviewed" once the
        // acknowledgement is on the route.
        const titleBadge = this._editedRouteNeedsWarningsReview() ? "Needs Review"
            : this._editedRouteWarningsReviewed() ? "Reviewed" : "";
        const titleBadgeVariant = titleBadge === "Reviewed" ? "success" : "danger";

        return this._renderFloatPanel("Route editor", innerHtml, true, false, titleBadge, titleBadgeVariant);
    }

    // Whether the route currently open in the editor still needs its precautionary zone warnings
    // reviewed. Gated on const_pow_endpoint_v2, like the rest of the review flow.
    private _editedRouteNeedsWarningsReview(): boolean {
        if (FeatureFlagModel?.hasFeatureFlag(CONST_POW_ENDPOINT_V2) !== true) {
            return false;
        }

        return routeNeedsWarningsReview(this._routeUnderReview());
    }

    /**
     * The route the badge should describe: the editor's live waypoints carrying the saved route's
     * route_info.
     *
     * The saved geometry only catches up on save, so reading it would leave the badge claiming a
     * review is outstanding after the user has just deleted the last precautionary zone waypoint.
     * The acknowledgement itself still comes from route_info, which the editor does not hold.
     */
    // Only the route editor panel reads the edited waypoints, so nothing else needs re-rendering.
    private _onEditedRouteChanged = () => {
        if (this.showInFloatPanel === "routeEditor") {
            this.requestUpdate();
        }
    };

    private _routeUnderReview(): VoyageRoute | null {
        const savedRoute = VoyageRoutingModel?.routes?.find(r => r.routeId === this._selectedRouteId);
        if (!savedRoute) {
            return null;
        }

        const editedWaypoints = RouteEditModel?.getWaypoints() ?? [];
        if (editedWaypoints.length === 0) {
            return savedRoute;
        }

        const routeUnderReview = <VoyageRoute>{ ...savedRoute, route_geometry: editedWaypoints };

        // An acknowledgement belongs to the crossings it was given for, so an edit that moves them
        // invalidates it - the same rule the recalculation carry-over applies. Without this the
        // badge would still read "Reviewed" while the editor has already reopened its review.
        const crossingsUnchanged =
            getZoneCrossingSignature(savedRoute.route_geometry as any[])
            === getZoneCrossingSignature(editedWaypoints as any[]);

        if (!crossingsUnchanged && routeUnderReview.route_info) {
            routeUnderReview.route_info = { ...routeUnderReview.route_info, routeWarningsReviewed: false };
        }

        return routeUnderReview;
    }

    // Whether the route open in the editor crosses precautionary zones that have already been
    // reviewed - the acknowledgement is persisted, so it survives leaving and reopening the editor.
    private _editedRouteWarningsReviewed(): boolean {
        if (FeatureFlagModel?.hasFeatureFlag(CONST_POW_ENDPOINT_V2) !== true) {
            return false;
        }

        return routeWarningsReviewed(this._routeUnderReview());
    }

    private _renderScheduleEditor() {
        const innerHtml = html`<vessel-edit-schedule @close-editor=${this._onFloatPanelBack}>
                                </vessel-edit-schedule>`;

        return this._renderFloatPanel("Schedule ports", innerHtml, true);
    }

    private _renderSuggestedRoutes() {
        let idSchedule = this.planningScheduleId;
        if(this.showPlanClicked !== ""){
            idSchedule = this.showPlanClicked;
        }
        const innerHtml = html`<voyage-suggested-routes @show-advice=${this._showAdviceModalHandler} @route-editor-click=${this._showWaypointEditor}
                                                        schedule-id=${this.planningScheduleId}
                                                        .setStarRouteLayerVisibility=${this.setStarRouteLayerVisibility.bind(this)}
                                                        @weather-limits-click=${() => this.showWeatherLimits = true }
                                                        @passage-plan-click=${(e: CustomEvent) => this._openPassagePlan(this.planningScheduleId, e) }
                                                        @selection-changed=${this._routeSelectionChanged}>
                              </voyage-suggested-routes>`;
        this.showPlanClicked="";
        return this._renderFloatPanel("Create/Upload Routes", innerHtml, true);
    }

    private _renderAlarmLogs() {
		this.showInFloatPanel = "alarmLogs";
		const innerHtml = html`<voy-vessel-alarm-log-list>
		</voy-vessel-alarm-log-list>`;

		return this._renderFloatPanel("Log", innerHtml, true);
	}

    private _renderCurrentSchedule() {
        const innerHtml = html`<voyage-vessel-details type="vessel"
                                                        imo=${this._vesselImoNumber}
                                                        @edit-plan=${this._editPlan}
                                                        @add-terminal=${this._addTerminal}
                                                        @view-plan=${this._viewPlan}
                                                        @show-passage-plan=${this.showPassagePlanFor}
                                                        @show-port-memo=${this._showPortMemo}
                                                        @edit-departure-times=${this._editDepartureTimes}
                                                        @edit-arrival-times=${this._editArrivalTimes}
                                                        @edit-drafts=${this._editDrafts}
                                                        @show-tide-information=${this._showTideInfo}
                                                        @edit-schedule=${this._editSchedule}
                                                        @show-eta-request=${this._showEtaRequest}>
                               </voyage-vessel-details>`;

        return this._renderFloatPanel("Current Schedule", innerHtml, false);
    }

    private _renderViewRoute() {
        const innerHtml = html`<voyage-view-route .scheduleId=${this.planningScheduleId}
                                                  @show-passage-plan=${ () => this._openPassagePlan(this.planningScheduleId) }></voyage-view-route>`;

        return this._renderFloatPanel("View Route", innerHtml, true);
    }

    private _renderFloatPanel(title: string, innerHtml?: TemplateResult, showBackButton?: boolean, showScroll: boolean = true, titleBadge: string = "", titleBadgeVariant: string = "danger") {
        return html `${this.showPolarTopBar ? html`` : html `${(title === "Polar Plot" && this.showPolarChart)? html `<voyage-float-panel guard-top=54
                                         @back-clicked=${() => this._onFloatPanelBack()} ?showScroll=${showScroll}
                                         style="width: 70rem; height: 100%" ?showCollapse=${false}>
                        ${innerHtml}
                    </voyage-float-panel>` : html`<voyage-float-panel guard-top=54
                                         panelTitle=${title}
                                         .titleBadge=${titleBadge}
                                         .titleBadgeVariant=${titleBadgeVariant}
                                         @back-clicked=${() => this._onFloatPanelBack()} ?show-back-button=${showBackButton} ?showScroll=${showScroll} ?showCollapse=${true}
                                         >
                        ${innerHtml}
                    </voyage-float-panel>`}`}`
    }

    private _renderFloatPanelForLoading(title: string, innerHtml?: TemplateResult, showBackButton?: boolean, showScroll: boolean = true){
        return html `
            <div class=${this._hideFloatPanel ? 'hidden-float-panel' : ''}>
                <voyage-float-panel
                    guard-top=54
                    ?showScroll=${showScroll}
                    style="width: 70rem; height: 100%"
                    ?showCollapse=${false}
                    @back-clicked=${() => {this._showEtaChangeFloatPanel = false;}}
                >
                    ${innerHtml}
                </voyage-float-panel>
            </div>
        `
    }

    private _showSchedule() {
        this.showInFloatPanel = "schedule";
        this.planningScheduleId = "";
        this._starRouteDeviationLayer?.clearRoutes();
        this._starRouteDeviationLayer?.layer?.setVisible(false);
        VoyageRoutingModel!.setActivePlan(null); // Clear any planning routes
        this._playerCore.currentTime = Date.now();
    }

    private _onFloatPanelBack = async () => {
        switch (this.showInFloatPanel)
        {
            case "alarmLogs":
            case "viewRoute":
            case "suggestedRoutes":
                this._showSchedule();
                break;
            case "routeEditor":
                if (RouteEditModel!.canRevert()) {
                    const dialog = VoyageDialogPopupManager.createDialog({
                        headerText: "Exit Route Editor",
                        bodyText: "Are you sure you want to exit the Route Editor?\n\nAll changes will be deleted.",
                        acceptButtonText: "Yes, Exit",
                        rejectButtonText: "No, Cancel"
                    });
                    if ((await dialog.getResponse()) !== "accept")
                    {
                        return;
                    }
                }
                this._selectedRouteId = '';
                this._focusZoneKey = '';
                this._starRouteDeviationLayer?.clearRoutes();
                this._starRouteDeviationLayer?.layer?.setVisible(false);
                this._planningLayers?.setSelectedZonePoint(''); // Clear the zone point highlight
                RouteEditModel!.clear();
                VesselPlanningModel?.dispatchEvent(new Event("reset-star-route-view")); // Clear if align route view is activated
                this.showInFloatPanel = "suggestedRoutes";
                break;
            case "scheduleEditor":
                this._showSchedule();
                break;
            case "polarPlot":
                this.polarRouteCapturedPosition = null;
                this.showPolarChart = false;
                this._showSchedule();
                break;
        }
    }

    private _routeSelectionChanged(evt: CustomEvent) {
        const color = evt.detail.color;
        this._routeEditLayer!.setColors( { lineColor: color });

    }

    private _focustimeUpdate(evt: CustomEvent) {
        const focustime = evt.detail.focustime;
        this._playerCore.currentTime = focustime;
    }

    private _togglePlayer(evt: CustomEvent) {
        const play = evt.detail.play;
        if (play) {
            this._playerCore.play();
            return;
        }

        this._playerCore.pause();
    }

    private _triggerUserFeedback() {
        this._showFeedback = true;
        this.showCloseIcon = true;
    }
      
    private _playbackRateUpdate(evt: CustomEvent) {
        const playbackrate = evt.detail.playbackrate;
        this._playerCore.playbackRate = playbackrate;
    }

    private _onMapCoordMove(evt: CustomEvent) {
        this._voyageInfo!.handleMove(evt);
    }

    private _onChangeWPEtaClicked(evt: CustomEvent) {
        this.wpPlanIndex = evt.detail.wpPlanIndex;
        this.showWPEtaInput = true;
    }

    private _onMapCoord(evt: CustomEvent) {
        this._voyageInfo!.handleClick(evt);
        this.mapCoordinates = evt.detail.pos;
        this._handleZonePointClick(evt.detail?.info);
    }

    // Opens the route editor's precautionary zone review on the clicked entry/exit marker. When the
    // editor is already showing that route only the focused point moves, otherwise the routes list
    // is asked to open the editor for it first.
    private _handleZonePointClick(info: { [key: string]: any } | undefined) {
        const markerType = info?.zoneMarkerType;
        if (markerType !== 'entry' && markerType !== 'exit') {
            return;
        }

        const routeId: string | undefined = info?.routeId;
        const zoneKey: string | undefined = info?.zoneKey;
        if (!routeId || !zoneKey) {
            return;
        }

        this._focusZoneKey = zoneKey;

        if (this.showInFloatPanel === 'routeEditor' && this._selectedRouteId === routeId) {
            return;
        }

        // Only the routes list can set up RouteEditModel for a route, so it opens the editor.
        const suggestedRoutes = <VoyageSuggestedRoutes | null>this.shadowRoot?.querySelector('voyage-suggested-routes');
        suggestedRoutes?.openRouteEditorForRoute(routeId);
        this.showFloatPanel();
    }

    private async _assignModels(mapConfig:any = {simplified: "true", level: "0"}) {
        const styles = getComputedStyle(this);

        setProgressModel(new ProgressModelImpl());
        this._navtexAllLayer = new NavtexLayer();
        this._navtexInForceLayer = new NavtexLayerInForce();

        this._executionLayer = new ExecutionLayer({
            defaultColor: styles.getPropertyValue('--neutrals-grey-01'),
            waypointOutlineColor: styles.getPropertyValue('--neutrals-grey-01'),
            waypointFillColor: styles.getPropertyValue('--waypoint-fill-color'),
            textColor: styles.getPropertyValue('--neutrals-grey-01'),
            passedColor: styles.getPropertyValue('--voyage-passed-line-color'),
            warningColor: styles.getPropertyValue('--warning-yellow-7'),
            avoidColor: styles.getPropertyValue('--voyage-error-red'),
            parametricRollColor: styles.getPropertyValue('--voyage-parametric-roll-color'),
            heavyRollingColor: styles.getPropertyValue('--voyage-heavy-rolling-color'),
            transverseAccelerationColor: styles.getPropertyValue('--voyage-transverse-acceleration-color')
        });
        this._vesselLayer = new VesselLayer();
        this._vesselTrackLayer = new VesselTrackLayer({trackColor: styles.getPropertyValue('--neutrals-grey-03')});
        this._routeEditLayer = new RouteEditLayer({
            lineColor: styles.getPropertyValue('--neutrals-grey-01'),
            waypointFillColor: styles.getPropertyValue('--waypoint-fill-color'),
            textColor: styles.getPropertyValue('--neutrals-grey-02'),
            textOutlineColor: styles.getPropertyValue('--neutrals-grey-10')
        });
        this._planningLayers = new PlanningLayers({
            uiRouteColors: [
                styles.getPropertyValue('--route1-color'),
                styles.getPropertyValue('--route2-color'),
                styles.getPropertyValue('--route3-color'),
                styles.getPropertyValue('--route4-color'),
                styles.getPropertyValue('--route5-color')
            ],
            warningColor: styles.getPropertyValue('--warning-yellow-7'),
            avoidColor: styles.getPropertyValue('--voyage-error-red'),
            parametricRollColor: styles.getPropertyValue('--voyage-parametric-roll-color'),
            heavyRollingColor: styles.getPropertyValue('--voyage-heavy-rolling-color'),
            transverseAccelerationColor: styles.getPropertyValue('--voyage-transverse-acceleration-color'),
            waypointFillColor: styles.getPropertyValue('--waypoint-fill-color'),
            passedColor: styles.getPropertyValue('--voyage-passed-line-color')
        });
        this._polarRouteLayer = new PolarRouteLayer();
        this._bufferLayers = new BufferLayers({
            uiRouteColors: [
                styles.getPropertyValue('--route1-color'),
                styles.getPropertyValue('--route2-color'),
                styles.getPropertyValue('--route3-color'),
                styles.getPropertyValue('--route4-color'),
                styles.getPropertyValue('--route5-color')
            ],
            warningColor: styles.getPropertyValue('--warning-yellow-7'),
            avoidColor: styles.getPropertyValue('--voyage-error-red'),
            parametricRollColor: styles.getPropertyValue('--voyage-parametric-roll-color'),
            heavyRollingColor: styles.getPropertyValue('--voyage-heavy-rolling-color'),
            transverseAccelerationColor: styles.getPropertyValue('--voyage-transverse-acceleration-color'),
            waypointFillColor: styles.getPropertyValue('--waypoint-fill-color'),
            passedColor: styles.getPropertyValue('--voyage-passed-line-color')
        });
        this._polarRouteLayer.addEventListener(PolarRouteLayerEvents.PolarCoordinateCaptured, <EventListener>((evt: CustomEvent) => {this.polarRouteCapturedPosition = [...evt.detail.lonLat], this.hasParametricRisk = evt.detail.hasParametricRisk, this.polarRouteCapturedPositionETA = evt.detail.nearestEta}));

        this._starRouteDeviationLayer = new StarRouteDeviationLayer();
        this._vesselInTimeLayers = new VesselInTimeLayers(this._playerCore, true, true, this._planningLayers);
        this._vesselInTimeLayers.addEventListener('vessel-in-time-position', <EventListener>((evt: CustomEvent) => this.vesselInTimePosition = evt.detail));
        this._spotWeatherMarkerLayer = new SpotWeatherMarkerLayer();
        this._shallowSoundingsLayer = new ShallowSoundingsLayer();
        this._enpBooksAndChaptersLayer = new EnpBooksAndChaptersLayer({ chapterBorderColor: styles.getPropertyValue('--enp-layers-chapterBorderColor'), 
                                                                        fillColor: styles.getPropertyValue('--enp-layers-fill-color'),
                                                                        bookBorderColor: styles.getPropertyValue('--enp-layers-bookBorderColor')
                                                                      });
        this._navAreasLayer = new NavAreasLayer({ fillColor: styles.getPropertyValue('--nav-areas-layers-fill-color'),
                                                  navAreaBorderColor: styles.getPropertyValue('--nav-areas-layers-color')
                                                });
        this._whaleZonesLayerAll = new WhaleZonesLayerAll({ fillColor: styles.getPropertyValue('--whale-zones-layers-fill-color'),
                                                            borderColor: styles.getPropertyValue('--whale-zones-layers-border-color'),
                                                            avoid: styles.getPropertyValue('--whale-zones-layers-avoid-color'),
                                                            restricted: styles.getPropertyValue('--whale-zones-layers-restricted-color')})                                        

        this._whaleZonesLayerInForce = new WhaleZonesLayerInForce({ fillColor: styles.getPropertyValue('--whale-zones-layers-fill-color'),
                                                                    borderColor: styles.getPropertyValue('--whale-zones-layers-border-color'),
                                                                    avoid: styles.getPropertyValue('--whale-zones-layers-avoid-color'),
                                                                    restricted: styles.getPropertyValue('--whale-zones-layers-restricted-color')})
        this._marpolLayer = new MarpolLayer({ fillColor: styles.getPropertyValue('--marpol-layer-fill-color'),
                                              borderColor: styles.getPropertyValue('--marpol-layer-border-color')});
        this._ecaSecaLayer = new EcaSecaLayer({ fillColor: styles.getPropertyValue('--eca-seca-layer-fill-color'),
                                              borderColor: styles.getPropertyValue('--eca-seca-layer-border-color')});
        this._bwmLayer = new BWMLayer({ fillColor: styles.getPropertyValue('--bwm-layer-fill-color'),
                                        borderColor: styles.getPropertyValue('--bwm-layer-border-color')});
        this._restrictedAreasLayer = new RestrictedAreasLayer({ fillColor: styles.getPropertyValue('--restricted-areas-layer-fill-color'),
                                                                borderColor: styles.getPropertyValue('--restricted-areas-layer-border-color')});
        this._securityLayer = new SecurityZonesLayer({ fillColor: styles.getPropertyValue('--security-layer-fill-color'),
                                                                borderColor: styles.getPropertyValue('--security-layer-border-color')});
        this._precautionaryZonesLayer = new PrecautionaryZonesLayer({ fillColor: styles.getPropertyValue('--precautionary-zones-layer-fill-color'),
                                                                borderColor: styles.getPropertyValue('--precautionary-zones-layer-border-color')});
        this._polarMarkerLayer = new PolarMarkerLayer();
                                                                
        await MgLayers!.initialize(mapConfig);
        await this._executionLayer.initialize();
        await this._vesselLayer.initialize();
        await this._vesselTrackLayer.initialize();
        await this._vesselInTimeLayers.initialize();
        await this._planningLayers.initialize();
        await this._bufferLayers.initialize();
        await this._starRouteDeviationLayer.initialize();
        await this._routeEditLayer.initialize();
        await this._polarRouteLayer.initialize();
        await this._enpBooksAndChaptersLayer.initialize();
        await this._navAreasLayer.initialize();
        await this._whaleZonesLayerAll.initialize();
        await this._whaleZonesLayerInForce.initialize();
        await this._marpolLayer.initialize();
        await this._ecaSecaLayer.initialize();
        await this._spotWeatherMarkerLayer.initialize();
        await this._shallowSoundingsLayer.initialize();
        await this._navtexAllLayer.initialize();
        await this._navtexInForceLayer.initialize();
        await this._bwmLayer.initialize();
        await this._restrictedAreasLayer.initialize();
        await this._securityLayer.initialize();
        await this._precautionaryZonesLayer.initialize();
        await this._polarMarkerLayer.initialize();

/*START.DEV_ONLY*/
        await DevLayers.initialize();
/*END.DEV_ONLY*/

        // MeteoGroup map
        this._mapElement!.initMaps(this._playerCore, [
            ...MgLayers!.layers,
            this._executionLayer.layer!,
            this._vesselTrackLayer.layer!,
            this._vesselLayer.layer!,
            ...this._vesselInTimeLayers.layers,
            ...this._planningLayers.layers,
            ...this._polarRouteLayer.layers,
            ...this._routeEditLayer.layers,
            ...this._enpBooksAndChaptersLayer.layers,
            ...this._navAreasLayer.layers,
            ...this._whaleZonesLayerAll.layers,
            ...this._whaleZonesLayerInForce.layers,
            ...this._marpolLayer.layers,
            ...this._ecaSecaLayer.layers,
            ...this._spotWeatherMarkerLayer.layers,
            ...this._shallowSoundingsLayer.layers,
            ...this._navtexAllLayer.layers,
            ...this._navtexInForceLayer.layers,
            ...this._bwmLayer.layers,
            ...this._restrictedAreasLayer.layers,
            ...this._securityLayer.layers,
            ...this._precautionaryZonesLayer.layers,
            ...this._bufferLayers.layers,
            this._starRouteDeviationLayer.layer!,
            this._polarMarkerLayer!.layer!,

/*START.DEV_ONLY*/
            ...DevLayers.layers
/*END.DEV_ONLY*/
        ]);
        this._mapElement!.routeLayers = [
            this._executionLayer.layer!,
            ...this._polarRouteLayer.layers,
            ...this._planningLayers.layers,
            ...this._enpBooksAndChaptersLayer.layers,
            ...this._navAreasLayer.layers,
            ...this._whaleZonesLayerAll.layers,
            ...this._whaleZonesLayerInForce.layers,
            ...this._marpolLayer.layers,
            ...this._ecaSecaLayer.layers,
            ...this._spotWeatherMarkerLayer.layers,
            ...this._shallowSoundingsLayer.layers,
            ...this._navtexAllLayer.layers,
            ...this._navtexInForceLayer.layers,
            ...this._bwmLayer.layers,
            ...this._restrictedAreasLayer.layers,
            ...this._securityLayer.layers,
            ...this._precautionaryZonesLayer.layers,
            ...this._bufferLayers.layers,
        ];

        this._routeEditLayer.assignMap(this._mapElement!.getMap()!);
        this._polarRouteLayer.assignMap(this._mapElement!.getMap()!);
        this._vesselInTimeLayers.assignMap(this._mapElement!.getMap()!);
        this._polarMarkerLayer.assignMap(this._mapElement!.getMap()!);

        VesselPlanningModel!.addEventListener(SuggestedRouteEvents.PlanChanged, <EventListener><any>this._onPlanChanged);
        VoyageRoutingModel!.addEventListener(SuggestedRouteEvents.RoutesChanged, <EventListener>(() => this.requestUpdate()));
        VesselPlanningModel!.addEventListener('executing-plan-changed', this._onExecutingPlanChanged);
        VesselPlanningModel!.addEventListener('heavy-rolling-alarm', <EventListener>this._onHeavyRollingAlarm.bind(this));
        VesselPlanningModel!.addEventListener('high-acceleration-force-alarm', <EventListener>this._onHighAccelerationForceAlarm.bind(this));
        VesselRs1345Model!.addEventListener(`fetch-html`, <EventListener>((evt: CustomEvent) => { this.rs1345Html = evt.detail.html; this.rs1345Address = evt.detail.address; this.showRs1345Popup = true }));

        this._initializeAlarmListener();

        this._spotWeatherMarkerLayer.enable();
        this._restrictedAreasLayer.enable();
        if (localStorage.getItem(ISHIGHLIGHTSHALLOWSOUNDINGSENABLED) === 'true') {
            this._shallowSoundingsLayer.enable();
        }
    }

    private _initializeAlarmListener() {
        // If model has already fetched alarms, process these before adding event listener
        if (VesselAlarmsModel!.alarms.length > 0) {
            this._handleAlarmUpdated();
        }
        VesselAlarmsModel!.addEventListener(AlarmEvents.AlarmsUpdated, () => {
            this._handleAlarmUpdated();
		});
    }

    private _handleAlarmUpdated() {
        this.isAlarmPopupOpen = false;

        // If clicking on edit option, alarmsOnEditOptions will be filled with alarm item
        if (VesselAlarmsModel!.alarmsOnEditOptions.length) {
            this._alarms = VesselAlarmsModel!.alarmsOnEditOptions;
            this._alarm  = VesselAlarmsModel!.alarmsOnEditOptions[0];
        } else if (VesselAlarmsModel!.alarmsWithoutResponses.length) {
            this._alarms = VesselAlarmsModel!.alarmsWithoutResponses;
            this._alarm = VesselAlarmsModel!.alarmsWithoutResponses[0];
        }
        this.alarmsCount = VesselAlarmsModel!.alarms.length ?? 0;
    }

    private _renderStarRouteDeviationBanner(): TemplateResult | typeof nothing {
        const planningViewActive = ["suggestedRoutes", "routeEditor"].includes(this.showInFloatPanel);
        if (!planningViewActive || !isStarRouteDeviationEnabled()) {
            return nothing;
        }

        const selectedRouteId = this._selectedRouteId || this.currentPlan?.currentSelectedRouteId;
        const selectedPlanRoute = selectedRouteId
            ? this.currentPlan?.routes?.find(route => route.routeId === selectedRouteId)
            : this.currentPlan?.routes?.[this.currentPlan.selectedRouteIndex];
        const selectedRoute = this._selectedRouteId
            ? VoyageRoutingModel?.routes.find(route => route.routeId === this._selectedRouteId) || selectedPlanRoute
            : selectedPlanRoute;
        const selectedRouteName = selectedRoute?.name || selectedPlanRoute?.name || 'Selected route';
        const segments = selectedRoute?.route_geometry
            ? getStarRouteDeviationSegments(selectedRoute.route_geometry)
            : [];

        const starRoutes = this.currentPlan?.routes?.filter(route =>
            route.routeCreatedBy === 'system' && route.uiType !== 'OOR'
        ) ?? [];
        const bprId = selectedRoute?.bprAlignment?.bprId;
        const matchingStarRoute = starRoutes.find(route =>
            route.bestPracticeRouteId === bprId || route.routeId === bprId
        );
        const routeNumber = matchingStarRoute?.name?.match(/Star\s*Route\s*(\d+)/i)?.[1]
            ?? (bprId ? undefined : '1')
            ?? (getMostFuelEfficientStarRoute(starRoutes)?.name?.match(/Star\s*Route\s*(\d+)/i)?.[1] ?? '1');
        const starRouteOne = starRoutes.find(route => route.name === 'Star Route 1');
        const selectedRouteFuel = this._getTotalRouteFuel(selectedRoute);
        const starRouteOneFuel = this._getTotalRouteFuel(starRouteOne);
        const isMoreFuelEfficient = selectedRoute?.routeCreatedBy !== 'system'
            && selectedRouteFuel !== undefined
            && starRouteOneFuel !== undefined
            && selectedRouteFuel < starRouteOneFuel;

        if (isMoreFuelEfficient && selectedRoute) {
            return html`<mc-notification
                heading=${`${selectedRouteName} is more fuel efficient than Star Route 1`}
                icon="check-circle"
                appearance="success"
                fit="medium">
            </mc-notification>`;
        }

        if (selectedRoute?.bprAlignment?.isAligned) {
            return html`<mc-notification
                heading=${`${selectedRouteName} is aligned to Star Route ${routeNumber}`}
                icon="check-circle"
                appearance="success"
                fit="medium">
            </mc-notification>`;
        }

        if (segments.length === 0) {
            return nothing;
        }

        const waypointLabels = segments.map(segment => segment.replace(/^Waypoints?\s+/, ''));
        const waypointSummary = waypointLabels.length > 1
            ? `${waypointLabels.slice(0, -1).join(', ')} & ${waypointLabels[waypointLabels.length - 1]}`
            : waypointLabels[0];

        return html`<mc-notification
            heading=${`${selectedRouteName} is not aligned with StarRoute ${routeNumber}`}
            icon="exclamation-triangle"
            appearance="warning"
            body=${`${waypointLabels.length > 1 ? 'Waypoints' : 'Waypoint'} ${waypointSummary} ${waypointLabels.length > 1 ? 'are' : 'is'} outside the permitted deviation.`}
            fit="medium">
            <div class="star-route-deviation-footnote">
                <div class="star-route-deviation-footnote__heading">Deviation limits</div>
                <div>Rhumbline legs: up to 10 NM</div>
                <div>Great-circle legs: up to 50 NM</div>
                <div class="star-route-deviation-footnote__legend">
                    <span class="star-route-deviation-footnote__line" aria-hidden="true"></span>
                    <span>The line marks the permitted deviation boundary around the StarRoute.</span>
                </div>
            </div>
        </mc-notification>`;
    }

    private _getTotalRouteFuel(route: VoyageRoute | undefined): number | undefined {
        const totals = route?.route_info?.totals;
        const nonEcaFuel = totals?.non_eca?.fuel;
        const ecaFuel = totals?.eca?.fuel ?? 0;
        if (typeof nonEcaFuel !== 'number' || !Number.isFinite(nonEcaFuel)
            || typeof ecaFuel !== 'number' || !Number.isFinite(ecaFuel)) {
            return undefined;
        }
        return nonEcaFuel + ecaFuel;
    }

    private async _onPlanChanged(evt: PlanChangedEvent) {
        const scheduleId = evt.detail.scheduleId;
        if (scheduleId === this.planningScheduleId)
        {
            this.currentPlan = await VesselPlanningModel!.getCurrentPlan(scheduleId);
        }
    }

    private async _onExecutingPlanChanged() {
        if (!this.planningScheduleId)
        {
            this.currentPlan = await VesselPlanningModel!.getExecutingPlan();
        }
    }

    private _onHeavyRollingAlarm(event: CustomEvent) {
        this._heavyRollingData = event.detail;
        this._showHeavyRollingToast = true;
    }

    private _onHighAccelerationForceAlarm(event: CustomEvent) {
        this._highAccelerationForceData = event.detail;
        this._showHighAccelerationForceToast = true;
    }

    private async _handleHeavyRollingAccept() {
        if (!this._heavyRollingData) return;

        const { id } = this._heavyRollingData;
        const notificationData = {
            state: "in-progress",
            data: JSON.stringify({
                reason: "Vessel acknowledged the risk",
            })
        };

        const result = await VesselAlarmsModel?.postAlarmsReasons(notificationData, id);

        if (result) {
            this._showHeavyRollingToast = false;
            this._heavyRollingData = null;
        }

        this._heavyRollingAcceptStatus = result ? 'success' : 'error';
    }

    private async _handleHighAccelerationForceAccept() {
        if (!this._highAccelerationForceData) return;

        const { id } = this._highAccelerationForceData;
        const notificationData = {
            state: "in-progress",
            data: JSON.stringify({
                reason: "Vessel acknowledged the risk",
            })
        };

        const result = await VesselAlarmsModel?.postAlarmsReasons(notificationData, id);

        if (result) {
            this._showHighAccelerationForceToast = false;
            this._highAccelerationForceData = null;
        }

        this._heavyRollingAcceptStatus = result ? 'success' : 'error';
    }

    private renderHeavyRollingWarning() {
        if(!this._showHeavyRollingToast || !this._heavyRollingData) return;

        const { data } = this._heavyRollingData;
        const date = GetFormattedDayMonth(data.start_time)
        const time = GetUTCTimestamp(data.start_time)

        return html`<mc-notification
            heading="Heavy Rolling Alarm"
            icon="emergency-light"
            appearance="warning"
            body=${`Risk of Heavy Rolling foreseen on ${date} at ${time}`}>
            <div><button @click=${()=>this._handleHeavyRollingAccept()}
                class="notification--action">Accept</button></div>
        </mc-notification>`
    }

    private renderHighAccelerationForceWarning() {
        if(!this._showHighAccelerationForceToast || !this._highAccelerationForceData) return;

        const { data } = this._highAccelerationForceData;
        const date = GetFormattedDayMonth(data.start_time)
        const time = GetUTCTimestamp(data.start_time)

        return html`<mc-notification
            heading="High Acceleration Force Alarm"
            icon="emergency-light"
            appearance="warning"
            body=${`Risk of High Acceleration Force foreseen on ${date} at ${time}`}>
            <div><button @click=${()=>this._handleHighAccelerationForceAccept()}
                class="notification--action">Accept</button></div>  
        </mc-notification>`
    }

    private renderHeavyAlarmAcceptedToast() {
        if (!this._heavyRollingAcceptStatus) return;

        const isError = this._heavyRollingAcceptStatus === 'error';
        const body = isError ? "Something went wrong, alarm could not be accepted." : "You have accepted this alarm.";

        return html`<mc-toast
                appearance=${isError ? "error" : "success"}
                ?open=${!!this._heavyRollingAcceptStatus}
                duration="100000"
                position="bottom-center"
                @close=${() => { this._heavyRollingAcceptStatus = null; }}>
                <mc-notification icon=${isError ? "exclamation-triangle" : "check-circle"} body=${body}></mc-notification>
        </mc-toast>`
    }

    private _handleRouteIdChange(starRouteId: string, routeId: string, fallbackStarRouteId?: string) {
        const styles = getComputedStyle(this);
        this._starRouteDeviationLayer!.setColors([
            styles.getPropertyValue('--route1-color'),
            styles.getPropertyValue('--route2-color'),
            styles.getPropertyValue('--route3-color'),
            styles.getPropertyValue('--route4-color'),
            styles.getPropertyValue('--route5-color')
        ]);
        this._starRouteDeviationLayer?.setScheduleId(this.planningScheduleId);
        this._starRouteDeviationLayer?.setRoutes(starRouteId, routeId, fallbackStarRouteId);
    }

    //We align routID to starRouteId
    public async setStarRouteLayerVisibility(starRouteId: string, routeId: string): Promise<void> {
        const starRouteOne = this.currentPlan?.routes?.find(route =>
            route.name?.replace(/\s+/g, '').toLowerCase() === 'starroute1'
        ) ?? VoyageRoutingModel?.routes.find(route =>
            route.name?.replace(/\s+/g, '').toLowerCase() === 'starroute1'
        ) ?? this.currentPlan?.routes?.find(route => route.routeCreatedBy === 'system')
            ?? VoyageRoutingModel?.routes.find(route => route.routeCreatedBy === 'system');
        const visible = !!starRouteId;

        if (this._starRouteDeviationLayer?.layer) {
            this._starRouteDeviationLayer.layer.setVisible?.(visible);
            this._handleRouteIdChange(starRouteId, routeId, starRouteOne?.routeId);
            this._selectedStarRoute = starRouteId;
            const allRoutes = VoyageRoutingModel!.routes;

            // If not visible, ensure all routes are shown
            if (!visible) {
                allRoutes.forEach(route => VoyageRoutingModel!._setRouteViewStatus(route.routeId, this.planningScheduleId, true));
            }
        }

        if (this._bufferLayers?.layers) {
            this._bufferLayers.layers.forEach(layer => {
                layer.setVisible?.(true);
            });
        }
    }

    private _stylesChanged() {
        const styles = getComputedStyle(this);

        this._executionLayer!.setColors({
            defaultColor: styles.getPropertyValue('--neutrals-grey-05'),
            waypointOutlineColor: styles.getPropertyValue('--neutrals-grey-01'),
            waypointFillColor: styles.getPropertyValue('--waypoint-fill-color'),
            textColor: styles.getPropertyValue('--neutrals-grey-01'),
            passedColor: styles.getPropertyValue('--voyage-passed-line-color'),
            warningColor: styles.getPropertyValue('--warning-yellow-7'),
            avoidColor: styles.getPropertyValue('--voyage-error-red'),
            parametricRollColor: styles.getPropertyValue('--voyage-parametric-roll-color'),
            heavyRollingColor: styles.getPropertyValue('--voyage-heavy-rolling-color'),
            transverseAccelerationColor: styles.getPropertyValue('--voyage-transverse-acceleration-color')
        });

        this._routeEditLayer!.setColors({
            lineColor: styles.getPropertyValue('--neutrals-grey-01'),
            waypointFillColor: styles.getPropertyValue('--waypoint-fill-color'),
            textColor: styles.getPropertyValue('--neutrals-grey-02'),
            textOutlineColor: styles.getPropertyValue('--neutrals-grey-10')
        });
        
        this._planningLayers!.setColors({
            uiRouteColors: [
                styles.getPropertyValue('--route1-color'),
                styles.getPropertyValue('--route2-color'),
                styles.getPropertyValue('--route3-color'),
                styles.getPropertyValue('--route4-color'),
                styles.getPropertyValue('--route5-color')
            ],
            warningColor: styles.getPropertyValue('--warning-yellow-7'),
            parametricRollColor: styles.getPropertyValue('--voyage-parametric-roll-color'),
            heavyRollingColor: styles.getPropertyValue('--voyage-heavy-rolling-color'),
            transverseAccelerationColor: styles.getPropertyValue('--voyage-transverse-acceleration-color'),
            waypointFillColor: styles.getPropertyValue('--waypoint-fill-color'),
            passedColor: styles.getPropertyValue('--voyage-passed-line-color')
        });
        this._bufferLayers!.setColors({
            uiRouteColors: [
                styles.getPropertyValue('--route1-color'),
                styles.getPropertyValue('--route2-color'),
                styles.getPropertyValue('--route3-color'),
                styles.getPropertyValue('--route4-color'),
                styles.getPropertyValue('--route5-color')
            ],
            warningColor: styles.getPropertyValue('--warning-yellow-7'),
            parametricRollColor: styles.getPropertyValue('--voyage-parametric-roll-color'),
            heavyRollingColor: styles.getPropertyValue('--voyage-heavy-rolling-color'),
            transverseAccelerationColor: styles.getPropertyValue('--voyage-transverse-acceleration-color'),
            waypointFillColor: styles.getPropertyValue('--waypoint-fill-color'),
            passedColor: styles.getPropertyValue('--voyage-passed-line-color')
        });

        this._enpBooksAndChaptersLayer!.setColors(
            { chapterBorderColor: styles.getPropertyValue('--enp-layers-chapterBorderColor'), 
              fillColor: styles.getPropertyValue('--enp-layers-fill-color'),
              bookBorderColor: styles.getPropertyValue('--enp-layers-bookBorderColor')
            });
        this._navAreasLayer!.setColors(
            { fillColor: styles.getPropertyValue('--nav-areas-layers-fill-color'),
              navAreaBorderColor: styles.getPropertyValue('--nav-areas-layers-color')
            }
        )
        this._whaleZonesLayerAll!.setColors(
            { fillColor: styles.getPropertyValue('--whale-zones-layers-fill-color'),
              borderColor: styles.getPropertyValue('--whale-zones-layers-border-color'),
              avoid: styles.getPropertyValue('--whale-zones-layers-avoid-color'),
              restricted: styles.getPropertyValue('--whale-zones-layers-restricted-color')}
        )
        this._whaleZonesLayerInForce!.setColors(
            { fillColor: styles.getPropertyValue('--whale-zones-layers-fill-color'),
              borderColor: styles.getPropertyValue('--whale-zones-layers-border-color'),
              avoid: styles.getPropertyValue('--whale-zones-layers-avoid-color'),
              restricted: styles.getPropertyValue('--whale-zones-layers-restricted-color'),
            }
        )
        this._marpolLayer!.setColors(
            { borderColor: styles.getPropertyValue('--marpol-layer-border-color'),
              fillColor: styles.getPropertyValue('--marpol-layer-fill-color')});
        this._restrictedAreasLayer?.setColors(
            { fillColor: styles.getPropertyValue('--restricted-areas-layer-fill-color'),
              borderColor: styles.getPropertyValue('--restricted-areas-layer-border-color')});
        
    }

    private _editPlan(evt: CustomEvent) {
        this.planningScheduleId = evt.detail.id;
        this.showLegDetails = true;
        this._tracingAnalyticsOnClick('Edit Plan');
    }

    private _viewPlan(evt: CustomEvent) {
        this.planningScheduleId = evt.detail.id;
        this.showInFloatPanel = "viewRoute";
        this._tracingAnalyticsOnClick('View Plan');
    }

    private async showPassagePlanFor(evt: CustomEvent) {
        this.planningScheduleId = evt.detail.id;

        const plan = await VesselPlanningModel!.getCurrentPlan(this.planningScheduleId);
        if (plan) {
            //commneted out to avoid the weather routing popup
            // handleWeatherRouting(plan,true); // need to check if this is opening from the schedule or from the view route
        }
        
        this._openPassagePlan(this.planningScheduleId);
        this._tracingAnalyticsOnClick('Show Passage Plan');
    }

    private async _onAcceptLegDetails() {
        this.showLegDetails = false;
        this.showInFloatPanel = "suggestedRoutes";
        this.currentPlan = await VesselPlanningModel!.getCurrentPlan(this.planningScheduleId);
        // if a future voyage is selected, set currentTime to depature time of said voyage
        this._playerCore.currentTime = this.currentPlan!.etd > Date.now() ? this.currentPlan!.etd : Date.now();
        this.checkOpenOceanRouteReadinessForSchedule(this.planningScheduleId);
    }

    private _onAcceptWeatherLimits() {
        this.showWeatherLimits = false;
    }

    private _showPortMemo(evt: CustomEvent) {
        this.portMemoTerminalCode = evt.detail.arrivalTerminalCode;
        this.portMemoShowPopup = true;
        this._tracingAnalyticsOnClick('Show Port Memo');
    }

    private _addTerminal(evt: CustomEvent) {
        const gsisEntry = evt.detail;

        if (!TerminalsModel!.getTerminal(gsisEntry.departureTerminalCode)) {
            this.addTerminalLocationID = gsisEntry.departureTerminalCode;
            this.addTerminalUnlocode = gsisEntry.departureTerminalUnLocode;
            this.addTerminalShowPopup = true;
        }
        else if (!TerminalsModel!.getTerminal(gsisEntry.arrivalTerminalCode)) {
            this.addTerminalLocationID = gsisEntry.arrivalTerminalCode;
            this.addTerminalUnlocode = gsisEntry.arrivalTerminalUnLocode;
            this.addTerminalShowPopup = true;
        }

        this._tracingAnalyticsOnClick('Add Terminal');
    }

    private _showTideInfo(evt: CustomEvent) {
        this.tideInfoPopupGsisEntry = evt.detail;
        this.showTideInfoPopup = true;
        
        this._tracingAnalyticsOnClick('Show Tide information');
    }

    private _showWaypointEditor(evt: CustomEvent) {
        this._selectedRouteId = evt.detail.routeId;
        this.showInFloatPanel = "routeEditor";
        void this.setStarRouteLayerVisibility(this._selectedStarRoute, this._selectedRouteId);
        this._tracingAnalyticsOnClick('Show Waypoint Editor');
    }

    private async _editDepartureTimes(evt: CustomEvent) {
        this.planningScheduleId = evt.detail.id;
        this.showEtdInput = true;
        this._tracingAnalyticsOnClick('Edit Departure Times');
    }

    private async _editArrivalTimes(evt: CustomEvent) {
        this.planningScheduleId = evt.detail.id;
        this.showEtaInput = true;
        this._tracingAnalyticsOnClick('Edit Arrival Times');
    }

    private async _editDrafts(evt: CustomEvent) {
        this.planningScheduleId = evt.detail.id;
        if (await this._hasPlanAndRoute(this.planningScheduleId)) {
            this.showDraftsInput = true;
            this._tracingAnalyticsOnClick('Edit Drafts');
        } else {
            this.showLegDetails = true;
        }
    }

    private async _showEtaRequest(evt: CustomEvent){
        this.showEtaRequest = true;
        this._showEtaChangeFloatPanel = true;
    }

    private _editSchedule() {
        this.showInFloatPanel = "scheduleEditor";
        this._tracingAnalyticsOnClick('Show schedule editor');
    }

    private async _hasPlanAndRoute(scheduleId: string) {
        const plan = await VesselPlanningModel!.getCurrentPlan(scheduleId);
        if (plan) {
            return plan.routes.length > 0;
        }
    }

    private async _checkVesselCharacteristics() {
        const chars = await VesselPlanningModel!.getVesselCharacteristics();
        if (!chars) {
            this.showVesselCharsInput = true;
        } 
        if ( !this.onlineStatus.isOnline && isVesselOnCloud ){
            this.showVesselCharsInput = false;
        }
    }

    private _notImplemented() {
        VoyageDialogPopupManager.createDialog({
            isError: true,
            headerText: "Not implemented",
            bodyText: "Functionality not implemented yet"
        });
    }

    private async _openPassagePlan(scheduleId: string, e?: CustomEvent)
    {
        if (e?.detail?.nonHydraCalculatedRoute) {
            this.selectedNonHydraCalculatedRoute = e.detail.nonHydraCalculatedRoute;
        } else {
            this.selectedNonHydraCalculatedRoute = null;
        }
        this.currentPlan = await VesselPlanningModel!.getCurrentPlan(scheduleId);
        this.showPassagePlan = true;
    }
    
    connectedCallback(): void {
        super.connectedCallback();
        VoyageImoModel?.addEventListener(VoyageImoEventNames.ImoUpdated, () => this._updateImo());
        VoyageImoModel!.addEventListener(VoyageImoEventNames.UnauthorizedImo, ()=>this.showImoError = true);
        VesselAlarmsModel?.addEventListener("show-alarm-logs",this._renderAlarmLogs);
        // The route editor's title badge is derived from the waypoints being edited, and editing
        // does not touch any of this component's own state - so re-render on every editor change.
        RouteEditModel?.addEventListener("route-changed", this._onEditedRouteChanged);
        window.addEventListener('online', async () => {
            console.log('Network is back online. Syncing requests manually...');
            // handle sync of pending request manually
            offlineBackgroundSyncManual();
          });
        if ("connection" in navigator) {
            (navigator as any).connection.addEventListener("change", async () => {
                console.log("Network changed: Main :", (navigator as any).connection);
                
                // Only check slow network offline if there are PUT calls for current IMO
                if (await this.hasPutCallsForCurrentIMO()) {
                    this.hasExceed15MinutesSlowNetworkOffline();
                }
            });
        }  
        this.getUpcomingSchedule().then(() => {
            this.checkPlanApprovalStatus();
        });
        this.checkOpenOceanRouteReadiness();
        this.trackOfflineTime();
        this.addEventListener(PolarLoadingModalEventNames.ClosePolarChartLoader, this._onFloatPanelBack);
        this.addEventListener(ScheduleChangeEvents.ReviewChange, this.handleReview as EventListener);
        this.addEventListener(ScheduleChangeEvents.EnableEtaRequest, (evt) => this._showEtaRequest(evt as CustomEvent));
        this.addEventListener(ImminentRiskEvents.hasImminentRisk,(evt: Event) => this.checkImminentRiskPolarPlot(evt as CustomEvent))
        this.addEventListener(ImminentRiskEvents.onboardAudioAlert, (evt: Event) => this.resumeAudioOnboarding(evt as CustomEvent))
        this._pollingInterval = setInterval(() => this._checkRemindLaterTime(), 5 * 60 * 1000);
    }

    disconnectedCallback(): void {
        super.disconnectedCallback();
        VesselAlarmsModel?.removeEventListener("show-alarm-logs",this._renderAlarmLogs)
        RouteEditModel?.removeEventListener("route-changed", this._onEditedRouteChanged);
        VoyageImoModel?.removeEventListener(VoyageImoEventNames.ImoUpdated, () => this._updateImo());
        VoyageImoModel!.removeEventListener(VoyageImoEventNames.UnauthorizedImo, ()=>this.showImoError = true);
        // No longer listening to featureFlagsUpdated since we don't re-setup listeners
        VoyageWeatherRoutingModel?.removeEventListener('show-wni-pdf', <EventListener><any>this._showAdviceModalHandler);
        VoyageWeatherRoutingModel?.removeEventListener('show-wni-pdf-id', <EventListener><any>this._showWrPdfModalHandler);
        this.removeEventListener(PolarLoadingModalEventNames.ClosePolarChartLoader, this._onFloatPanelBack);
        this.removeEventListener(ScheduleChangeEvents.ReviewChange, this.handleReview as EventListener);
        this.removeEventListener(ScheduleChangeEvents.EnableEtaRequest, (evt) => this._showEtaRequest(evt as CustomEvent));
        this.removeEventListener(ImminentRiskEvents.hasImminentRisk,(evt: Event) => this.checkImminentRiskPolarPlot(evt as CustomEvent))
        this.removeEventListener(ImminentRiskEvents.onboardAudioAlert, (evt: Event) => this.resumeAudioOnboarding(evt as CustomEvent))
        clearInterval(this._pollingInterval);
    }

	private _updateImo = () => {
		this._vesselImoNumber = VoyageImoModel!.imo;
        UiStateModel?.setValue(UiStateModelParam.IMO, VoyageImoModel!.imo?.toString())
        this.showImoError = false;
        this._showSchedule();
        this._checkVesselCharacteristics();
        LoadstarModel?.checkExistsByImo(this._vesselImoNumber);
        this.checkOpenOceanRouteReadiness();
		this.requestUpdate();
	}


    private _openFeedBackPopup(){
        VesselFeedbackStatusModel!.getVesselFeedback()
    }
    @property({ type: Boolean }) showAdviceModal = false;
    @property({ type: String }) pdfUrl = '/assets/images/mock.pdf#toolbar=0'; 

    private async _showAdviceModalHandler(event: CustomEvent) {
        VesselLoaderManager.createLoader(
            {
                headerText: 'Loading PDF',
                showCancelButton: false,
                onCancel: () => {
                    this.showAdviceModal = false;
                }
            }
        );
        
        try {
            const wrId = event.detail.wrId;
            if (!wrId) throw new Error('No Wr ID provided');
           
            await this._showWrPdfModalHandler({ detail: { wrId: wrId.toString() } } as CustomEvent);
        } catch (error) {
            console.error('Error in _showAdviceModalHandler:', error);
        } finally {
            // Ensure the loader is always removed, even on early returns or errors
            VesselLoaderManager.removeLoader();
        }
    }

    private async _showWrPdfModalHandler(event: CustomEvent) {
        const wrId = event.detail.wrId;
        const pdfBlob = await VoyageWeatherRoutingModel?.getWRPdf(wrId);
        if (!pdfBlob) throw new Error('Failed to fetch WR PDF');
        this.pdfUrl = URL.createObjectURL(pdfBlob) + '#toolbar=0#view=Fit';
        this.showAdviceModal = true;
    }
    
    private _handleCloseModal(){
        this.showAdviceModal = false 
    }
    
    private  _showAdviceModal() {
        return html`<mc-modal
            heading=${`New advice`}
            ?open=${true}
            dimension="small"
            width="auto"
            height="auto"
            backdropcloseactiondisabled
            escapecloseactiondisabled
            entercloseactiondisabled
            hiddenclose
        >
        ${this.showAdviceModal ?
        html`
        <iframe 
            src=${this.pdfUrl}
            width="auto"
            height="auto"
            class="modal-iframe-style">
        </iframe> 
        <mc-button class="close-modal-styles" variant="filled" appearance="primary" @click=${this._handleCloseModal}>Close</mc-button>
        `:
        html`<p>No PDF available. </p>`
        }
        </mc-modal> `
    }

    @property({attribute: false}) private showPlanClicked: string = "";
    
    private async _onAcceptLegDetailsShowPlan(evt: CustomEvent) {
        try {
            this.planningScheduleId = evt.detail.scheduleId;
            this.showLegDetails = false;
            this.showInFloatPanel = "suggestedRoutes";
            this.checkOpenOceanRouteReadinessForSchedule(this.planningScheduleId);
        } catch (error) {
            console.error("Error in _onAcceptLegDetailsShowPlan:", error);
        }
    }

    private async _checkENCUpdates() {
        try {
            // Skip ENC update check if vessel is on cloud
            const appenv = (<any>window)["appenv"];
            if (appenv?.vesselOnCloud === true) {
                return;
            }

            // Check if we've already shown the alert in this session
            const encAlertShown = sessionStorage.getItem('enc-outdated-alert-shown');
            if (encAlertShown) {
                return;
            }

            const encData = await ENCDataService.getENCData();
            const isOutdated = ENCDataService.isENCOutdated(encData.lastUpdated);
            
            if (isOutdated) {
                const daysSinceUpdate = ENCDataService.getDaysSinceUpdate(encData.lastUpdated);
                const lastUpdateDate = new Date(encData.lastUpdated).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
                
                VesselAlertsModel!.addAlert((<any>window)["appenv"].vesselIMONumber, {
                    title: "Update the ENC charts",
                    message: `ENC charts in StarConnect have not been updated for ${daysSinceUpdate} days (last updated: ${lastUpdateDate}). Please follow the procedure to update the ENC charts in this application.`,
                    id: `enc-outdated-${encData.lastUpdated}`,
                    type: AlertType.OutdatedENC,
                });
                
                // Mark as shown for this session to avoid repeated alerts
                sessionStorage.setItem('enc-outdated-alert-shown', 'true');
            }
        } catch (err) {
            console.error('Error checking ENC updates:', err);
        }
    }

    private async _checkEtaEtdAlerts() {
        //if trinity is on, then don't show the schedule change alert popup as it is handled by trinity for ongoing schedules and in pre-departure phase
        if(this._TrinityOn)
            return;

        const alerts = await VesselNotificationsService.fetchAlerts(NotificationTypes.ETAAlerts);
        alerts.length > 0 && alerts.map(async (alert: { data: any;id:string }) => {
            this.formatAlertMessage(alerts[0].data);
            const dialog =  VoyageDialogPopupManager.createDialog({
                headerText: "ETA/ETD Alerts ",
                bodyText: this.formatAlertMessage(alert.data),
                acceptButtonText: "Accept",
            });
            const response = await dialog.getResponse();
            if (response === "accept")
            {
                await VesselNotificationsService.acceptAlerts(alert.id);
            }
        });
        
    }
    private formatAlertMessage(alerts:any): string {
        const formattedMessages = alerts.map((alert: { fromDate: string | number | Date; toDate: string | number | Date; alertFor: any; }) => {
            const fromDate = GetFormattedDate(alert.fromDate);
            const toDate = GetFormattedDate(alert.toDate);
            return `${alert.alertFor} berth has been changed from ${fromDate} LT to ${toDate} LT\n`;
        });
        return formattedMessages.join(' and ');
    }

    private addNoPlanAlert(message: string, idSuffix: string) {
        VesselAlertsModel!.addAlert((<any>window)["appenv"].vesselIMONumber, {
            message,
            id: `${this.upcomingSchedule.id}-${idSuffix}`,
            type: AlertType.NoPlanPreEtd,
        });
    }

    async checkPlanApproval() {
        try {
            await this.getUpcomingSchedule();
            const noPlanPreEtdFeedbacks = await VesselNotificationsService.fetchNotifications(NotificationTypes.NoPlanPreEtd);
            const notificationData = noPlanPreEtdFeedbacks.find(feedback => {
                const data = feedback.data; 
                return data.schedule_id === this.upcomingSchedule.id;
            });
            this.hoursToEtd = notificationData ? notificationData.data.timeToEtd : null;

            if(this.upcomingSchedule && this.hoursToEtd){
                this.plan = await VesselPlanningModel!.getCurrentPlan(this.upcomingSchedule.id);
                const handleAlerts = () => {
                    if (this.plan && this.plan.status !== "approved" || !this.plan) {
                        if (this.hoursToEtd === 60) {
                            if (this.plan?.passagePlan && this.plan.status !== "approved") {
                                this.addNoPlanAlert(
                                    NotificationMessageType.NoApprovedPlanMessage,
                                    "60hours-update"
                                );
                            } else if (!this.plan) {
                                this.addNoPlanAlert(
                                    NotificationMessageType.NoPlanMessage,
                                    "60hours-plan"
                                );
                            }
                        } else if (this.hoursToEtd && this.hoursToEtd < 60 && this.hoursToEtd > 48) {
                            this.addNoPlanAlert(
                                `Please be aware, that the voyage plan has to be ready for weather routing within the next ${this.hoursToEtd - 48} hours. Kindly consider finalizing the planning task for timely submission.`,
                                `${new Date().getTime()}hours-warning`
                            );
                        }

                    }
                };
    
                handleAlerts();

                if (this.hoursToEtd < 60 && this.hoursToEtd > 48) {
                    const intervalId = setInterval(async () => {
                        this.plan = await VesselPlanningModel!.getCurrentPlan(this.upcomingSchedule.id);

                        if (this.plan && this.plan.status === "approved") {
                            clearInterval(intervalId); 
                        } else {
                            handleAlerts(); 
                        }
                    }, 4 * 60 * 60 * 1000); //every 4 hour
                }
            }            
        } catch (error) {
          console.error(error);
        }
      }

      async checkPreDepaturePlan(){
        await this.getUpcomingSchedule();
        if(this.upcomingSchedule){

            this.plan = await VesselPlanningModel!.getCurrentPlan(this.upcomingSchedule.id);
            if ((this.plan && this.plan.status !== "approved") || !this.plan) {
                this.triggerAlert(this.plan);
            }

            // Interval to check every 12 hours
            const intervalId = setInterval(async () => {
                this.plan = await VesselPlanningModel!.getCurrentPlan(this.upcomingSchedule.id);
                if (this.plan && this.plan.status === "approved") {
                    clearInterval(intervalId); // Stop further checks
                } else {
                    this.triggerAlert(this.plan);
                }
            }, 12 * 60 * 60 * 1000);
        }
      }

      async triggerAlert(plan: VoyagePlan | null) {
        const noPlanPreEtdFeedbacks = await VesselNotificationsService.fetchNotifications(NotificationTypes.NoPlanPreEtd);
        const notificationData = noPlanPreEtdFeedbacks.find(feedback => {
            const data = feedback.data;
            return data.schedule_id === this.upcomingSchedule.id;
        });
        const hoursToEtd = notificationData ? notificationData.data.timeToEtd : null;
        if ((plan && plan.status !== "approved" || !plan) && hoursToEtd && hoursToEtd <= 48) {
            this.addNoPlanAlert(`Please select a Star Route if available or create your own route and submit it at your earliest convenience. There are ${hoursToEtd} hours to ETD, and your voyage plan may be subject to weather routing.`, `${new Date().getTime()}`)
        }
    }

    private trackOfflineTime(): void {
        window.addEventListener('offline', () => {
            if (!sessionStorage.getItem(this.OFFLINE_START_KEY)) {
                sessionStorage.setItem(this.OFFLINE_START_KEY, Date.now().toString());
            }
        });

        window.addEventListener('online', () => {
            // Reset when connection is restored
            sessionStorage.removeItem(this.OFFLINE_START_KEY);
        });

        // Check on load if already offline
        if (!isOnline() && !sessionStorage.getItem(this.OFFLINE_START_KEY)) {
            sessionStorage.setItem(this.OFFLINE_START_KEY, Date.now().toString());
        }

        // Also clear if back online on load
        if (isOnline() && sessionStorage.getItem(this.OFFLINE_START_KEY)) {
            sessionStorage.removeItem(this.OFFLINE_START_KEY);
        }
    }

    private async hasPutCallsForCurrentIMO(): Promise<boolean> {
        if (!this._vesselImoNumber) return false;
        
        try {
            const allRequests = await IndexedDBSyncService.request.getAll();
            
            // Check if any stored request is a PUT call for the current IMO
            return allRequests.some(syncRequest => {
                const url = syncRequest.id; // URL is stored as the id
                const method = syncRequest.request?.method;
                
                // Check if it's a PUT request and contains the current IMO
                return method === 'PUT' && url.includes(`imo=${this._vesselImoNumber}`);
            });
        } catch (error) {
            console.error('Error checking sync database for PUT calls:', error);
            return false;
        }
    }

    private hasExceeded72HoursOffline(): boolean {
    const offlineStart = sessionStorage.getItem(this.OFFLINE_START_KEY);
    if (!offlineStart) return false;

    const offlineStartTime = parseInt(offlineStart, 10);
    const now = Date.now();
    const diffInMs = now - offlineStartTime;

    return diffInMs >= 72 * 60 * 60 * 1000; // 72 hours in ms
    }

    private async measureBandwidth() {
    const start = performance.now();
    await fetch(`${window.location.protocol}//${window.location.host}/version.json?cache=${Date.now()}`);
    const end = performance.now();

    const duration = end - start;
    return duration;
    }

    private hasExceed15MinutesSlowNetworkOffline() {
        console.log("Slow network detected, starting check interval");
        
        // Function to check network and handle logic
        const checkNetwork = async () => {
            const latency = await this.measureBandwidth();
            if (latency < 2000) {
                console.log("Network seems fast again");
                window.dispatchEvent(new CustomEvent('backToFastNetwork', {
                    detail: {
                        timestamp: Date.now(),
                        val: 'yes'
                    }
                }));
                // handle sync of pending request manually
                offlineBackgroundSyncManual();
                // Stop the interval once sync is executed
                clearInterval(intervalId);
            } else {
                 window.dispatchEvent(new CustomEvent('backToFastNetwork', {
                    detail: {
                        timestamp: Date.now(),
                        val: 'no'
                    }
                }));
            }
        };

        // Execute immediately for the first time
        checkNetwork();
        
        // Then continue with 1-minute intervals
        const intervalId = setInterval(checkNetwork, 60000); // 1 minute
    }

    private async handleRemindLater(e: CustomEvent): Promise<void>{
        if(!this._showEtaChangeFloatPanel && e.detail.alertId){
            const requestedEta = e.detail.requestedEta; 
            const imo = getCurrentVesselImo();
            if (imo) {
                VesselAlertsModel!.addAlert(imo, {
                    message: `Please review the ETA Change Request to ${requestedEta} and take an immediate action.`,
                    id: 'eta-reminder-id',
                    type: AlertType.EtaChangeRemindLater,
                });
            }

            // Add minimized view if not already present
            const alreadyExists = this.minimizedViews.some(v => v.type === NotificationTypes.RequestETAChange);
            if (!alreadyExists) {
                this.minimizedViews = [
                ...this.minimizedViews,
                { name: 'ETA Change', type: NotificationTypes.RequestETAChange },
                ];
            }
            localStorage.setItem('RemindLaterView', new Date().toISOString())
        }
    }  

    private handleReview(e: CustomEvent){
        this.showEtaRequest = false;
        this._showEtaChangeFloatPanel = true;
        const imo = getCurrentVesselImo();
        if (imo) {
            VesselAlertsModel!.removeAlertsByType(imo, AlertType.EtaChangeRemindLater);
        }
        this.minimizedViews = this.minimizedViews.filter(v => v.type !== NotificationTypes.RequestETAChange);
    }

    private handleLoadstarReview = async () => {
        this.showLoadstarReviewModal = true;
    }

    private async _checkRemindLaterTime() {
    const remindLaterTime = localStorage.getItem('RemindLaterView');
    if (!remindLaterTime) return;

    const remindLaterTimestamp = new Date(remindLaterTime).getTime();
    const now = Date.now();
    
        if (!this._showEtaChangeFloatPanel && (now - remindLaterTimestamp >= 30 * 60 * 1000)) { // 30 mins passed
            // Trigger ETA reminder logic again
            const currentAlert = ScheduleChangeModel!.getCurrentAlert();
            const requestedTime = currentAlert?.data.schedule.arrivalTimings.array.find((item : any) => item.type === 'ESTIMATED')?.timestamp;
            const requestedTimeLT = await formatEtaDate(requestedTime, currentAlert?.data.arrival_terminal_code);
            const imo = getCurrentVesselImo();
            if (imo) {
                VesselAlertsModel!.addAlert(imo, {
                    message: `Please review the ETA Change Request to ${requestedTimeLT} and take an immediate action.`,
                    id: 'eta-reminder-id',
                    type: AlertType.EtaChangeRemindLater,
                });
            }

            const alreadyExists = this.minimizedViews.some(v => v.type === NotificationTypes.RequestETAChange);
            if (!alreadyExists) {
                this.minimizedViews = [
                ...this.minimizedViews,
                { name: 'ETA Change', type: NotificationTypes.RequestETAChange },
                ];
            }
        }    
    }

    private async checkImminentRiskPolarPlot(e: CustomEvent){
        this.log_id = e.detail.log_id || localStorage.getItem('imminentRiskLogId');
        this.showInFloatPanel = "polarPlot";
        this.hasImminentRisk = true;
        this.minimizedViews = this.minimizedViews.filter(v => v.type !== NotificationTypes.ImminentRisk);
    }

    private async resumeAudioOnboarding(e: CustomEvent){
        this.showOnboardAudioModal = true;
         this.minimizedViews = this.minimizedViews.filter(v => v.type !== NotificationTypes.ImminentRiskOnboard);
    }

    private async checkInProgressImminentRisk(e: CustomEvent){
        const alreadyExists = this.minimizedViews.some(v => v.type === NotificationTypes.ImminentRisk);
            if (!alreadyExists) {
                this.minimizedViews = [
                    ...this.minimizedViews,
                    { name: 'Polar Chart', type: NotificationTypes.ImminentRisk },
                ];
            }
    }
    
    private async fetchImminentRiskOnboard(){
        const showOnboardAudioModal = await ImminentRiskModel!.fetchImminentRiskOnboard();

        this.showOnboardAudioModal = showOnboardAudioModal;
    }

    /**
     * Initialize feature-based models after feature flags are loaded
     */
    private async _initializeFeatureBasedModels(featureFlagModel: FeatureFlagModelImpl) {
        try {
            // Wait for feature flags to be initialized
            await featureFlagModel.waitForInitialization();
            
            // Read the actual feature flag values from localStorage
            this._WeatherRoutingOn = localStorage.getItem(ISWEATHERROUTINGENABLED) === "true";
            this._TrinityOn = localStorage.getItem(ISTRINITYENABLED) === "true";
            
            this._ImminentRiskOn = localStorage.getItem(ISIMMINENTRISKENABLED) === "true";
            this._LoadstarOn = localStorage.getItem(ISLOADSTARENABLED) === "true";

            console.log(`Feature flags loaded: Weather Routing: ${this._WeatherRoutingOn}, Trinity: ${this._TrinityOn}, Imminent Risk: ${this._ImminentRiskOn}, Loadstar: ${this._LoadstarOn}`);

            // Enable the shallow-soundings map layer once flags are known. The layer may not be
            // initialized yet at this point; enable() remembers the intent, and the map-init
            // check covers the case where flags resolved before the map was set up.
            if (localStorage.getItem(ISHIGHLIGHTSHALLOWSOUNDINGSENABLED) === 'true') {
                this._shallowSoundingsLayer?.enable();
            }

            // Initialize Loadstar models if enabled
            if(this._LoadstarOn) {
                setLoadstarModel(new LoadstarModelImpl());
                LoadstarModel?.addEventListener(LoadstarEvents.ReviewChanges, this.handleLoadstarReview as EventListener);
                console.log('Loadstar model initialized');
            }
            
            // Initialize weather routing models if enabled
            if(this._WeatherRoutingOn) {
                setVoyageWeatherRoutingModel(new VoyageWeatherRoutingModelImpl());
                setWeatherRoutingModel(new WeatherRoutingModelImpl());
                console.log('Weather routing models initialized');
                
                // Set up weather routing event listeners (moved from constructor)
                VoyageWeatherRoutingModel!.addEventListener(ACCEPT_SHOW_PLAN, <EventListener><any>this._onAcceptLegDetailsShowPlan);
                
                // Set up PDF modal event listeners after model is initialized
                VoyageWeatherRoutingModel!.addEventListener('show-wni-pdf', <EventListener><any>this._showAdviceModalHandler);
                VoyageWeatherRoutingModel!.addEventListener('show-wni-pdf-id', <EventListener><any>this._showWrPdfModalHandler);
                
                // Handle counter proposal notifications for weather routing
                const counterProposalNotification = localStorage.getItem('wrRejected');
                if(counterProposalNotification) {
                    const parsedNotification = JSON.parse(counterProposalNotification);
                    VesselAlertsModel!.addAlert((<any>window)["appenv"].vesselIMONumber, {
                        message: `Counter Proposal Rejected`,
                        id: UUID(),
                        type: AlertType.CounterProposalNotification,
                    });
                }
            }
            
            // Initialize trinity models if enabled  
            if(this._TrinityOn) {
                setScheduleChangeModel(new ScheduleChangeModelImpl());
                console.log('Trinity models initialized');

                ScheduleChangeModel?.addEventListener(ScheduleChangeEvents.RemindLater, this.handleRemindLater as unknown as EventListener);
                ScheduleChangeModel?.addEventListener(ScheduleChangeEvents.ReviewChange, () => {this._showEtaChangeFloatPanel = true;});
                ScheduleChangeModel?.addEventListener(ScheduleChangeEvents.UserFlowEnd, this.handleBack);
            }

            // Initialize imminent risk models if enabled
            if(this._ImminentRiskOn){
                setImminentRiskModel(new ImminentRiskModelImpl());
                this.fetchImminentRiskOnboard();
                console.log('Imminent Risk models initialized');

                ImminentRiskModel?.addEventListener(ImminentRiskEvents.onboardAudioAlert, (evt: Event) => this.resumeAudioOnboarding(evt as CustomEvent))
                ImminentRiskModel?.addEventListener(ImminentRiskEvents.hasImminentRisk,(evt: Event) => this.checkImminentRiskPolarPlot(evt as CustomEvent))
                ImminentRiskModel?.addEventListener(ImminentRiskEvents.hasInprogressImminentRisk,(evt: Event) => this.checkInProgressImminentRisk(evt as CustomEvent))
                ImminentRiskModel?.addEventListener(ImminentRiskEvents.UserFlowEnd, this.removeImminentRiskMinimizedView);
            }

            // Dispatch event to notify that feature-based initialization is complete
            window.dispatchEvent(new CustomEvent(FeatureFlagsEvents.featureBasedFlagsInitialized, {
                detail: { 
                    weatherRoutingEnabled: this._WeatherRoutingOn,
                    trinityEnabled: this._TrinityOn,
                    imminentRiskEnabled: this._ImminentRiskOn,
                    loadstarEnabled: this._LoadstarOn
                }
            }));
            
        } catch (error) {
            console.error('Failed to initialize feature-based models:', error);
            // Set defaults if feature flag loading fails
            this._WeatherRoutingOn = false;
            this._TrinityOn = false;
            this._LoadstarOn = false;
        }
    }    
}
